//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const GSSCOMMON_API_BASE_URL = new InjectionToken<string>('GSSCOMMON_API_BASE_URL');

export interface IBioNexusClient {
    /**
     * Retrieve the BioNexus/Biological material Lot by Lot ID
     * @param id Lot ID  to search
     * @return Success
     */
    retrieveBioNexusLotByLotId(id: string): Observable<MaterialResult[]>;
    /**
     * Retrieve the BioNexus/Biological material by Bio material ID
     * @param id Bio material ID  to search
     * @return Success
     */
    retrieveBioNexusMaterialById(id: string): Observable<MaterialResult[]>;
    /**
     * Retrieve the BioNexus/Biological materials by For Glp
     * @param synonym Synonym search
     * @return Success
     */
    retrieveBioNexusMaterialsBySynonymForGlp(synonym: string): Observable<MaterialResult[]>;
    /**
     * Retrieve the BioNexus/Biological materials by For Stock
     * @param synonym Synonym search
     * @return Success
     */
    retrieveBioNexusMaterialsBySynonymForStock(synonym: string): Observable<MaterialResult[]>;
}

@Injectable({
    providedIn: 'root'
})
export class BioNexusClient implements IBioNexusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve the BioNexus/Biological material Lot by Lot ID
     * @param id Lot ID  to search
     * @return Success
     */
    retrieveBioNexusLotByLotId(id: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/BioNexus/RetrieveBioNexusLotByLotId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBioNexusLotByLotId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBioNexusLotByLotId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveBioNexusLotByLotId(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve the BioNexus/Biological material by Bio material ID
     * @param id Bio material ID  to search
     * @return Success
     */
    retrieveBioNexusMaterialById(id: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/BioNexus/RetrieveBioNexusMaterialById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBioNexusMaterialById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBioNexusMaterialById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveBioNexusMaterialById(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve the BioNexus/Biological materials by For Glp
     * @param synonym Synonym search
     * @return Success
     */
    retrieveBioNexusMaterialsBySynonymForGlp(synonym: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/BioNexus/RetrieveBioNexusMaterialsBySynonymForGlp/{synonym}";
        if (synonym === undefined || synonym === null)
            throw new Error("The parameter 'synonym' must be defined.");
        url_ = url_.replace("{synonym}", encodeURIComponent("" + synonym));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBioNexusMaterialsBySynonymForGlp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBioNexusMaterialsBySynonymForGlp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveBioNexusMaterialsBySynonymForGlp(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve the BioNexus/Biological materials by For Stock
     * @param synonym Synonym search
     * @return Success
     */
    retrieveBioNexusMaterialsBySynonymForStock(synonym: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/BioNexus/RetrieveBioNexusMaterialsBySynonymForStock/{synonym}";
        if (synonym === undefined || synonym === null)
            throw new Error("The parameter 'synonym' must be defined.");
        url_ = url_.replace("{synonym}", encodeURIComponent("" + synonym));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveBioNexusMaterialsBySynonymForStock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveBioNexusMaterialsBySynonymForStock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveBioNexusMaterialsBySynonymForStock(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }
}

export interface ICoformulantClient {
    /**
     * Retrieve a list of Coformulants which contain the name in trade name or common name
     * @param name Partial or complete name to search
     * @return Success
     */
    retrieveCoformulantsByName(name: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Field Inerts which contain the name in trade name or common name
     * @param name Partial or complete name to search
     * @return Success
     */
    retrieveFieldInertsByName(name: string): Observable<MaterialResult[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CoformulantClient implements ICoformulantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a list of Coformulants which contain the name in trade name or common name
     * @param name Partial or complete name to search
     * @return Success
     */
    retrieveCoformulantsByName(name: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Coformulants/RetrieveCoformulantsByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCoformulantsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCoformulantsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveCoformulantsByName(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Field Inerts which contain the name in trade name or common name
     * @param name Partial or complete name to search
     * @return Success
     */
    retrieveFieldInertsByName(name: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Coformulants/RetrieveFieldInertsByName/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFieldInertsByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFieldInertsByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFieldInertsByName(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }
}

export interface ICompositeInventoryClient {
    /**
     * Retrieve a list of Coformulants which contain the name in trade name or common name
     * @param repoName Repo Name
     * @param materialId Material Id
     * @param uom Unit of measure
     * @param includeZeroQuantityLots Include zero quantity lots
     * @return Success
     */
    retrieveCompositeInventory(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]>;
    /**
     * @return Success
     */
    retrieveCompositeInventoryDigest(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]>;
    /**
     * @return Success
     */
    retrieveCompositeInventoryWithStorageLoc(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]>;
}

@Injectable({
    providedIn: 'root'
})
export class CompositeInventoryClient implements ICompositeInventoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a list of Coformulants which contain the name in trade name or common name
     * @param repoName Repo Name
     * @param materialId Material Id
     * @param uom Unit of measure
     * @param includeZeroQuantityLots Include zero quantity lots
     * @return Success
     */
    retrieveCompositeInventory(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]> {
        let url_ = this.baseUrl + "/CompositeInventory/CompositeInventory/{repoName}/{materialId}/{uom}/{includeZeroQuantityLots}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        if (includeZeroQuantityLots === undefined || includeZeroQuantityLots === null)
            throw new Error("The parameter 'includeZeroQuantityLots' must be defined.");
        url_ = url_.replace("{includeZeroQuantityLots}", encodeURIComponent("" + includeZeroQuantityLots));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompositeInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompositeInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompositeInventoryResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompositeInventoryResult[]>;
        }));
    }

    protected processRetrieveCompositeInventory(response: HttpResponseBase): Observable<CompositeInventoryResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompositeInventoryResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompositeInventoryResult[]>(null as any);
    }

    /**
     * @return Success
     */
    retrieveCompositeInventoryDigest(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]> {
        let url_ = this.baseUrl + "/CompositeInventory/CompositeInventoryDigest/{repoName}/{materialId}/{uom}/{includeZeroQuantityLots}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        if (includeZeroQuantityLots === undefined || includeZeroQuantityLots === null)
            throw new Error("The parameter 'includeZeroQuantityLots' must be defined.");
        url_ = url_.replace("{includeZeroQuantityLots}", encodeURIComponent("" + includeZeroQuantityLots));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompositeInventoryDigest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompositeInventoryDigest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompositeInventoryResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompositeInventoryResult[]>;
        }));
    }

    protected processRetrieveCompositeInventoryDigest(response: HttpResponseBase): Observable<CompositeInventoryResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompositeInventoryResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompositeInventoryResult[]>(null as any);
    }

    /**
     * @return Success
     */
    retrieveCompositeInventoryWithStorageLoc(repoName: string, materialId: string, uom: string, includeZeroQuantityLots: boolean): Observable<CompositeInventoryResult[]> {
        let url_ = this.baseUrl + "/CompositeInventory/CompositeInventoryWithStorageLoc/{repoName}/{materialId}/{uom}/{includeZeroQuantityLots}";
        if (repoName === undefined || repoName === null)
            throw new Error("The parameter 'repoName' must be defined.");
        url_ = url_.replace("{repoName}", encodeURIComponent("" + repoName));
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        if (uom === undefined || uom === null)
            throw new Error("The parameter 'uom' must be defined.");
        url_ = url_.replace("{uom}", encodeURIComponent("" + uom));
        if (includeZeroQuantityLots === undefined || includeZeroQuantityLots === null)
            throw new Error("The parameter 'includeZeroQuantityLots' must be defined.");
        url_ = url_.replace("{includeZeroQuantityLots}", encodeURIComponent("" + includeZeroQuantityLots));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompositeInventoryWithStorageLoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompositeInventoryWithStorageLoc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompositeInventoryResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompositeInventoryResult[]>;
        }));
    }

    protected processRetrieveCompositeInventoryWithStorageLoc(response: HttpResponseBase): Observable<CompositeInventoryResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CompositeInventoryResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompositeInventoryResult[]>(null as any);
    }
}

export interface ICompoundClient {
    /**
     * Retrieve a list of compounds (typically 1) by CORE material ID
     * @param materialIdCore CORE Material ID
     * @return Success
     */
    retrieveCompoundByMaterialId(materialIdCore: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of compounds by synonym
     * @param synonym CORE synonym
     * @return Success
     */
    retrieveCompoundBySynonym(synonym: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of compounds by TSN
     * @param tsn CORE TSN
     * @return Success
     */
    retrieveCompoundByTSN(tsn: string): Observable<MaterialResult[]>;
    /**
     * Retrives the compound lot by using lotId
     * @return Success
     */
    retrieveCompoundLotsByLotId(lotId: string): Observable<MaterialResult[]>;
    /**
     * @return Success
     */
    retrieveMaterialModelCompoundByMaterialId(materialIdCore: string): Observable<MaterialModel>;
}

@Injectable({
    providedIn: 'root'
})
export class CompoundClient implements ICompoundClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a list of compounds (typically 1) by CORE material ID
     * @param materialIdCore CORE Material ID
     * @return Success
     */
    retrieveCompoundByMaterialId(materialIdCore: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Compounds/RetrieveCompoundByMaterialId/{materialIdCore}";
        if (materialIdCore === undefined || materialIdCore === null)
            throw new Error("The parameter 'materialIdCore' must be defined.");
        url_ = url_.replace("{materialIdCore}", encodeURIComponent("" + materialIdCore));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompoundByMaterialId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompoundByMaterialId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveCompoundByMaterialId(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of compounds by synonym
     * @param synonym CORE synonym
     * @return Success
     */
    retrieveCompoundBySynonym(synonym: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Compounds/RetrieveCompoundBySynonym/{synonym}";
        if (synonym === undefined || synonym === null)
            throw new Error("The parameter 'synonym' must be defined.");
        url_ = url_.replace("{synonym}", encodeURIComponent("" + synonym));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompoundBySynonym(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompoundBySynonym(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveCompoundBySynonym(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of compounds by TSN
     * @param tsn CORE TSN
     * @return Success
     */
    retrieveCompoundByTSN(tsn: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Compounds/RetrieveCompoundByTSN/{tsn}";
        if (tsn === undefined || tsn === null)
            throw new Error("The parameter 'tsn' must be defined.");
        url_ = url_.replace("{tsn}", encodeURIComponent("" + tsn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompoundByTSN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompoundByTSN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveCompoundByTSN(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrives the compound lot by using lotId
     * @return Success
     */
    retrieveCompoundLotsByLotId(lotId: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Compounds/RetrieveCompoundLotsByLotId/{lotId}";
        if (lotId === undefined || lotId === null)
            throw new Error("The parameter 'lotId' must be defined.");
        url_ = url_.replace("{lotId}", encodeURIComponent("" + lotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveCompoundLotsByLotId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveCompoundLotsByLotId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveCompoundLotsByLotId(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * @return Success
     */
    retrieveMaterialModelCompoundByMaterialId(materialIdCore: string): Observable<MaterialModel> {
        let url_ = this.baseUrl + "/Compounds/RetrieveMaterialModelCompoundByMaterialId/{materialIdCore}";
        if (materialIdCore === undefined || materialIdCore === null)
            throw new Error("The parameter 'materialIdCore' must be defined.");
        url_ = url_.replace("{materialIdCore}", encodeURIComponent("" + materialIdCore));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveMaterialModelCompoundByMaterialId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveMaterialModelCompoundByMaterialId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialModel>;
        }));
    }

    protected processRetrieveMaterialModelCompoundByMaterialId(response: HttpResponseBase): Observable<MaterialModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = MaterialModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialModel>(null as any);
    }
}

export interface IDocumentClient {
    /**
     * Creates a new document.
     * @param body (optional) Create request, including file payload
     * @return Success
     */
    create(body: DocumentCreateRequest | undefined): Observable<DocumentResponse>;
    /**
     * Retrieves a document, including the actual 
    file itself, by the unique ID.
     * @param iD Document ID
     * @return Success
     */
    retrieve(iD: string): Observable<DocumentResponse>;
    /**
     * Updates a document's meta data. Omitting a field will cause that 
    change to be ignored during the update.
     * @param iD Document ID
     * @param body (optional) Update request
     * @return Success
     */
    update(iD: string, body: DocumentUpdateRequest | undefined): Observable<DocumentResponse>;
    /**
     * Deletes a document.
     * @param iD Document ID
     * @return Success
     */
    delete(iD: string): Observable<void>;
    /**
     * Copies an existing document.
     * @param iD Original document ID
     * @param body (optional) Copy request that includes a new reference ID
     * @return Success
     */
    copy(iD: string, body: DocumentCopyRequest | undefined): Observable<DocumentResponse>;
    /**
     * Retrieves a document's metadata only based on the unique ID.
     * @param iD Document ID
     * @return Success
     */
    retrieveDocumentMetadata(iD: string): Observable<DocumentResponse>;
    /**
     * Downloads the document the actual 
    file itself, by the unique ID.
     * @param iD Document ID
     * @return Success
     */
    download(iD: string): Observable<DocumentResponse>;
    /**
     * Retrieve a list of documents matching the product 
    source system and product identifier specified.
     * @param sourceSystem Product source system
     * @param identifier Product identifier
     * @return Success
     */
    retrieveByMaterial(sourceSystem: string, identifier: string): Observable<DocumentResponse[]>;
    /**
     * Retrieve a list of documents matching the product 
    source system, product identifier, and lot number specified.
     * @param sourceSystem Product source system
     * @param identifier Product identifier
     * @param lotNumber Lot number
     * @return Success
     */
    retrieveByMaterialAndLot(sourceSystem: string, identifier: string, lotNumber: string): Observable<DocumentResponse[]>;
    /**
     * Retrieve a list of documents with the same 
    reference ID. This does not bring back the 
    file itself.
     * @param iD Reference ID to search
     * @return Success
     */
    retrieveByReferenceID(iD: string): Observable<DocumentResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentClient implements IDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new document.
     * @param body (optional) Create request, including file payload
     * @return Success
     */
    create(body: DocumentCreateRequest | undefined): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Retrieves a document, including the actual 
    file itself, by the unique ID.
     * @param iD Document ID
     * @return Success
     */
    retrieve(iD: string): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processRetrieve(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Updates a document's meta data. Omitting a field will cause that 
    change to be ignored during the update.
     * @param iD Document ID
     * @param body (optional) Update request
     * @return Success
     */
    update(iD: string, body: DocumentUpdateRequest | undefined): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Deletes a document.
     * @param iD Document ID
     * @return Success
     */
    delete(iD: string): Observable<void> {
        let url_ = this.baseUrl + "/Documents/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Copies an existing document.
     * @param iD Original document ID
     * @param body (optional) Copy request that includes a new reference ID
     * @return Success
     */
    copy(iD: string, body: DocumentCopyRequest | undefined): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents/{ID}/Copy";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Retrieves a document's metadata only based on the unique ID.
     * @param iD Document ID
     * @return Success
     */
    retrieveDocumentMetadata(iD: string): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents/{ID}/Metadata";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveDocumentMetadata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveDocumentMetadata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processRetrieveDocumentMetadata(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Downloads the document the actual 
    file itself, by the unique ID.
     * @param iD Document ID
     * @return Success
     */
    download(iD: string): Observable<DocumentResponse> {
        let url_ = this.baseUrl + "/Documents/Download/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<DocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = DocumentResponse.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse>(null as any);
    }

    /**
     * Retrieve a list of documents matching the product 
    source system and product identifier specified.
     * @param sourceSystem Product source system
     * @param identifier Product identifier
     * @return Success
     */
    retrieveByMaterial(sourceSystem: string, identifier: string): Observable<DocumentResponse[]> {
        let url_ = this.baseUrl + "/Documents/RetrieveByMaterial/{sourceSystem}/{identifier}";
        if (sourceSystem === undefined || sourceSystem === null)
            throw new Error("The parameter 'sourceSystem' must be defined.");
        url_ = url_.replace("{sourceSystem}", encodeURIComponent("" + sourceSystem));
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveByMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveByMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse[]>;
        }));
    }

    protected processRetrieveByMaterial(response: HttpResponseBase): Observable<DocumentResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentResponse.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse[]>(null as any);
    }

    /**
     * Retrieve a list of documents matching the product 
    source system, product identifier, and lot number specified.
     * @param sourceSystem Product source system
     * @param identifier Product identifier
     * @param lotNumber Lot number
     * @return Success
     */
    retrieveByMaterialAndLot(sourceSystem: string, identifier: string, lotNumber: string): Observable<DocumentResponse[]> {
        let url_ = this.baseUrl + "/Documents/RetrieveByMaterial/{sourceSystem}/{identifier}/{lotNumber}";
        if (sourceSystem === undefined || sourceSystem === null)
            throw new Error("The parameter 'sourceSystem' must be defined.");
        url_ = url_.replace("{sourceSystem}", encodeURIComponent("" + sourceSystem));
        if (identifier === undefined || identifier === null)
            throw new Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        if (lotNumber === undefined || lotNumber === null)
            throw new Error("The parameter 'lotNumber' must be defined.");
        url_ = url_.replace("{lotNumber}", encodeURIComponent("" + lotNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveByMaterialAndLot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveByMaterialAndLot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse[]>;
        }));
    }

    protected processRetrieveByMaterialAndLot(response: HttpResponseBase): Observable<DocumentResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentResponse.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse[]>(null as any);
    }

    /**
     * Retrieve a list of documents with the same 
    reference ID. This does not bring back the 
    file itself.
     * @param iD Reference ID to search
     * @return Success
     */
    retrieveByReferenceID(iD: string): Observable<DocumentResponse[]> {
        let url_ = this.baseUrl + "/Documents/RetrieveByReferenceID/{ID}";
        if (iD === undefined || iD === null)
            throw new Error("The parameter 'iD' must be defined.");
        url_ = url_.replace("{ID}", encodeURIComponent("" + iD));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveByReferenceID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveByReferenceID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentResponse[]>;
        }));
    }

    protected processRetrieveByReferenceID(response: HttpResponseBase): Observable<DocumentResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentResponse.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentResponse[]>(null as any);
    }
}

export interface IDocumentTypeClient {
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveList(): Observable<DocumentType[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentTypeClient implements IDocumentTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveList(): Observable<DocumentType[]> {
        let url_ = this.baseUrl + "/DocumentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentType[]>;
        }));
    }

    protected processRetrieveList(response: HttpResponseBase): Observable<DocumentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentType.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentType[]>(null as any);
    }
}

export interface IFormulationClient {
    /**
     * @return Success
     */
    confidentialCompositionById(compositionId: number): Observable<ConfidentialComposition>;
    /**
     * @return Success
     */
    retrieveConfidentialLotByLotName(lotName: string): Observable<ConfidentialLotCompositionModel[]>;
    /**
     * @param lotName (optional) 
     * @param manufacturerLotId (optional) 
     * @param tsnNumber (optional) 
     * @return Success
     */
    retreveConfidentialLots(lotName: string | undefined, manufacturerLotId: string | undefined, tsnNumber: string | undefined): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Formulations which contain the name in Corteva trade name
     * @param tradeNameCorteva Partial or complete name to search
     * @return Success
     */
    retrieveFormulationsByCortevaTradeName(tradeNameCorteva: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Formulations which match the given Formulation ID
     * @param formulationId complete Formulation Id to search
     * @return Success
     */
    retrieveFormulationsByFormulationId(formulationId: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Formulations which contain the name in synonym
     * @param synonym Partial or complete synonym to search
     * @return Success
     */
    retrieveFormulationsBySynonym(synonym: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Formulations which contain the name in Third Party trade name
     * @param tradeNameThirdParty Partial or complete name to search
     * @return Success
     */
    retrieveFormulationsByThirdPartyTradeName(tradeNameThirdParty: string): Observable<MaterialResult[]>;
    /**
     * Retrieve a list of Formulations which match the TSN
     * @param tsn TSN to search
     * @return Success
     */
    retrieveFormulationsByTSN(tsn: string): Observable<MaterialResult[]>;
    /**
     * @return Success
     */
    retrieveSpecialControlCompositionById(materialId: number): Observable<ConfidentialComposition>;
}

@Injectable({
    providedIn: 'root'
})
export class FormulationClient implements IFormulationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    confidentialCompositionById(compositionId: number): Observable<ConfidentialComposition> {
        let url_ = this.baseUrl + "/Formulations/ConfidentialCompositionById/{compositionId}";
        if (compositionId === undefined || compositionId === null)
            throw new Error("The parameter 'compositionId' must be defined.");
        url_ = url_.replace("{compositionId}", encodeURIComponent("" + compositionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfidentialCompositionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfidentialCompositionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfidentialComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfidentialComposition>;
        }));
    }

    protected processConfidentialCompositionById(response: HttpResponseBase): Observable<ConfidentialComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfidentialComposition.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfidentialComposition>(null as any);
    }

    /**
     * @return Success
     */
    retrieveConfidentialLotByLotName(lotName: string): Observable<ConfidentialLotCompositionModel[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveConfidentialLotByLotName/{lotName}";
        if (lotName === undefined || lotName === null)
            throw new Error("The parameter 'lotName' must be defined.");
        url_ = url_.replace("{lotName}", encodeURIComponent("" + lotName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveConfidentialLotByLotName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveConfidentialLotByLotName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfidentialLotCompositionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfidentialLotCompositionModel[]>;
        }));
    }

    protected processRetrieveConfidentialLotByLotName(response: HttpResponseBase): Observable<ConfidentialLotCompositionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ConfidentialLotCompositionModel.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfidentialLotCompositionModel[]>(null as any);
    }

    /**
     * @param lotName (optional) 
     * @param manufacturerLotId (optional) 
     * @param tsnNumber (optional) 
     * @return Success
     */
    retreveConfidentialLots(lotName: string | undefined, manufacturerLotId: string | undefined, tsnNumber: string | undefined): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveConfidentialLots?";
        if (lotName === null)
            throw new Error("The parameter 'lotName' cannot be null.");
        else if (lotName !== undefined)
            url_ += "lotName=" + encodeURIComponent("" + lotName) + "&";
        if (manufacturerLotId === null)
            throw new Error("The parameter 'manufacturerLotId' cannot be null.");
        else if (manufacturerLotId !== undefined)
            url_ += "manufacturerLotId=" + encodeURIComponent("" + manufacturerLotId) + "&";
        if (tsnNumber === null)
            throw new Error("The parameter 'tsnNumber' cannot be null.");
        else if (tsnNumber !== undefined)
            url_ += "tsnNumber=" + encodeURIComponent("" + tsnNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetreveConfidentialLots(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetreveConfidentialLots(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetreveConfidentialLots(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Formulations which contain the name in Corteva trade name
     * @param tradeNameCorteva Partial or complete name to search
     * @return Success
     */
    retrieveFormulationsByCortevaTradeName(tradeNameCorteva: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveFormulationsByCortevaTradeName/{tradeNameCorteva}";
        if (tradeNameCorteva === undefined || tradeNameCorteva === null)
            throw new Error("The parameter 'tradeNameCorteva' must be defined.");
        url_ = url_.replace("{tradeNameCorteva}", encodeURIComponent("" + tradeNameCorteva));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFormulationsByCortevaTradeName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFormulationsByCortevaTradeName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFormulationsByCortevaTradeName(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Formulations which match the given Formulation ID
     * @param formulationId complete Formulation Id to search
     * @return Success
     */
    retrieveFormulationsByFormulationId(formulationId: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveFormulationsByFormulationId/{formulationId}";
        if (formulationId === undefined || formulationId === null)
            throw new Error("The parameter 'formulationId' must be defined.");
        url_ = url_.replace("{formulationId}", encodeURIComponent("" + formulationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFormulationsByFormulationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFormulationsByFormulationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFormulationsByFormulationId(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Formulations which contain the name in synonym
     * @param synonym Partial or complete synonym to search
     * @return Success
     */
    retrieveFormulationsBySynonym(synonym: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveFormulationsBySynonym/{synonym}";
        if (synonym === undefined || synonym === null)
            throw new Error("The parameter 'synonym' must be defined.");
        url_ = url_.replace("{synonym}", encodeURIComponent("" + synonym));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFormulationsBySynonym(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFormulationsBySynonym(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFormulationsBySynonym(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Formulations which contain the name in Third Party trade name
     * @param tradeNameThirdParty Partial or complete name to search
     * @return Success
     */
    retrieveFormulationsByThirdPartyTradeName(tradeNameThirdParty: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveFormulationsByThirdPartyTradeName/{tradeNameThirdParty}";
        if (tradeNameThirdParty === undefined || tradeNameThirdParty === null)
            throw new Error("The parameter 'tradeNameThirdParty' must be defined.");
        url_ = url_.replace("{tradeNameThirdParty}", encodeURIComponent("" + tradeNameThirdParty));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFormulationsByThirdPartyTradeName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFormulationsByThirdPartyTradeName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFormulationsByThirdPartyTradeName(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * Retrieve a list of Formulations which match the TSN
     * @param tsn TSN to search
     * @return Success
     */
    retrieveFormulationsByTSN(tsn: string): Observable<MaterialResult[]> {
        let url_ = this.baseUrl + "/Formulations/RetrieveFormulationsByTSN/{tsn}";
        if (tsn === undefined || tsn === null)
            throw new Error("The parameter 'tsn' must be defined.");
        url_ = url_.replace("{tsn}", encodeURIComponent("" + tsn));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveFormulationsByTSN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveFormulationsByTSN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialResult[]>;
        }));
    }

    protected processRetrieveFormulationsByTSN(response: HttpResponseBase): Observable<MaterialResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaterialResult.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialResult[]>(null as any);
    }

    /**
     * @return Success
     */
    retrieveSpecialControlCompositionById(materialId: number): Observable<ConfidentialComposition> {
        let url_ = this.baseUrl + "/Formulations/RetrieveSpecialControlCompositionById/{materialId}";
        if (materialId === undefined || materialId === null)
            throw new Error("The parameter 'materialId' must be defined.");
        url_ = url_.replace("{materialId}", encodeURIComponent("" + materialId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveSpecialControlCompositionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveSpecialControlCompositionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfidentialComposition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfidentialComposition>;
        }));
    }

    protected processRetrieveSpecialControlCompositionById(response: HttpResponseBase): Observable<ConfidentialComposition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ConfidentialComposition.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfidentialComposition>(null as any);
    }
}

export interface IITCIntegrationClient {
    /**
     * Searches for Partner
     * @param body (optional) PartnerSearch request
     * @return Success
     */
    searchForPartner(body: PartnerSearch | undefined): Observable<PartnerResult>;
    /**
     * Searches for product
     * @param body (optional) ProductSearch request
     * @return Success
     */
    searchForProduct(body: ProductSearch | undefined): Observable<ProductResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ITCIntegrationClient implements IITCIntegrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for Partner
     * @param body (optional) PartnerSearch request
     * @return Success
     */
    searchForPartner(body: PartnerSearch | undefined): Observable<PartnerResult> {
        let url_ = this.baseUrl + "/ITCIntegration/PartnerSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchForPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerResult>;
        }));
    }

    protected processSearchForPartner(response: HttpResponseBase): Observable<PartnerResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = PartnerResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerResult>(null as any);
    }

    /**
     * Searches for product
     * @param body (optional) ProductSearch request
     * @return Success
     */
    searchForProduct(body: ProductSearch | undefined): Observable<ProductResult> {
        let url_ = this.baseUrl + "/ITCIntegration/ProductSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchForProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductResult>;
        }));
    }

    protected processSearchForProduct(response: HttpResponseBase): Observable<ProductResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = ProductResult.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductResult>(null as any);
    }
}

export interface IITCWebhookClient {
    /**
     * Updates Partner's particulars based on information sent from AmberRoad
     * @param body (optional) Partner Update request
     * @return Success
     */
    partnerOut(body: string | undefined): Observable<void>;
    /**
     * Updates Product's particulars based on information sent from AmberRoad
     * @param body (optional) Product Update request
     * @return Success
     */
    productOut(body: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ITCWebhookClient implements IITCWebhookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Updates Partner's particulars based on information sent from AmberRoad
     * @param body (optional) Partner Update request
     * @return Success
     */
    partnerOut(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ITCWebhook/PartnerOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/xml",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPartnerOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Updates Product's particulars based on information sent from AmberRoad
     * @param body (optional) Product Update request
     * @return Success
     */
    productOut(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/ITCWebhook/ProductOut";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/xml",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProductOut(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404, _mappings);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ILanguageClient {
    /**
     * Returns a list of languages.
     * @return Success
     */
    retrieveList2(): Observable<Language[]>;
}

@Injectable({
    providedIn: 'root'
})
export class LanguageClient implements ILanguageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of languages.
     * @return Success
     */
    retrieveList2(): Observable<Language[]> {
        let url_ = this.baseUrl + "/Languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveList2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Language[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Language[]>;
        }));
    }

    protected processRetrieveList2(response: HttpResponseBase): Observable<Language[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Language.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Language[]>(null as any);
    }
}

export interface IRaceLabelsClient {
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForComposition(compositionName: string): Observable<RaceResponseModel>;
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForCompositionByCountry(compositionName: string, countryCode: string, countryName: string): Observable<RaceResponseModel>;
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForFormulation(formulationNo: string): Observable<RaceResponseModel>;
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForFormulation2(formulationNo: string, countryCode: string, countryName: string): Observable<RaceResponseModel>;
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForRegisteredName(registeredName: string): Observable<RaceResponseModel>;
    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForRegisteredNameByCountry(registeredName: string, countryCode: string, countryName: string): Observable<RaceResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class RaceLabelsClient implements IRaceLabelsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForComposition(compositionName: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForComposition/{compositionName}";
        if (compositionName === undefined || compositionName === null)
            throw new Error("The parameter 'compositionName' must be defined.");
        url_ = url_.replace("{compositionName}", encodeURIComponent("" + compositionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForComposition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForComposition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForComposition(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForCompositionByCountry(compositionName: string, countryCode: string, countryName: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForCompositionByCountry/{compositionName}/{countryCode}/{countryName}";
        if (compositionName === undefined || compositionName === null)
            throw new Error("The parameter 'compositionName' must be defined.");
        url_ = url_.replace("{compositionName}", encodeURIComponent("" + compositionName));
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        if (countryName === undefined || countryName === null)
            throw new Error("The parameter 'countryName' must be defined.");
        url_ = url_.replace("{countryName}", encodeURIComponent("" + countryName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForCompositionByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForCompositionByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForCompositionByCountry(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForFormulation(formulationNo: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForFormulation/{formulationNo}";
        if (formulationNo === undefined || formulationNo === null)
            throw new Error("The parameter 'formulationNo' must be defined.");
        url_ = url_.replace("{formulationNo}", encodeURIComponent("" + formulationNo));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForFormulation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForFormulation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForFormulation(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForFormulation2(formulationNo: string, countryCode: string, countryName: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForFormulationByCountry/{formulationNo}/{countryCode}/{countryName}";
        if (formulationNo === undefined || formulationNo === null)
            throw new Error("The parameter 'formulationNo' must be defined.");
        url_ = url_.replace("{formulationNo}", encodeURIComponent("" + formulationNo));
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        if (countryName === undefined || countryName === null)
            throw new Error("The parameter 'countryName' must be defined.");
        url_ = url_.replace("{countryName}", encodeURIComponent("" + countryName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForFormulation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForFormulation2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForFormulation2(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForRegisteredName(registeredName: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForRegisteredName/{registeredName}";
        if (registeredName === undefined || registeredName === null)
            throw new Error("The parameter 'registeredName' must be defined.");
        url_ = url_.replace("{registeredName}", encodeURIComponent("" + registeredName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForRegisteredName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForRegisteredName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForRegisteredName(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }

    /**
     * Returns a list of document types.
     * @return Success
     */
    retrieveLabelsForRegisteredNameByCountry(registeredName: string, countryCode: string, countryName: string): Observable<RaceResponseModel> {
        let url_ = this.baseUrl + "/RaceLabels/RetrieveLabelsForRegisteredNameByCountry/{registeredName}/{countryCode}/{countryName}";
        if (registeredName === undefined || registeredName === null)
            throw new Error("The parameter 'registeredName' must be defined.");
        url_ = url_.replace("{registeredName}", encodeURIComponent("" + registeredName));
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        if (countryName === undefined || countryName === null)
            throw new Error("The parameter 'countryName' must be defined.");
        url_ = url_.replace("{countryName}", encodeURIComponent("" + countryName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveLabelsForRegisteredNameByCountry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveLabelsForRegisteredNameByCountry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RaceResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RaceResponseModel>;
        }));
    }

    protected processRetrieveLabelsForRegisteredNameByCountry(response: HttpResponseBase): Observable<RaceResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result200 = RaceResponseModel.fromJS(resultData200, _mappings);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RaceResponseModel>(null as any);
    }
}

export interface IReservationsClient {
    /**
     * Searches for Alchemist Reservations
     * @param body (optional) ReservationSearch Input
     * @return Success
     */
    search(body: ReservationSearchInput | undefined): Observable<ReservationsSearchResults[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ReservationsClient implements IReservationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(GSSCOMMON_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for Alchemist Reservations
     * @param body (optional) ReservationSearch Input
     * @return Success
     */
    search(body: ReservationSearchInput | undefined): Observable<ReservationsSearchResults[]> {
        let url_ = this.baseUrl + "/Reservations/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReservationsSearchResults[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReservationsSearchResults[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ReservationsSearchResults[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        let _mappings: { source: any, target: any }[] = [];
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReservationsSearchResults.fromJS(item, _mappings));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400, _mappings);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : jsonParse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401, _mappings);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReservationsSearchResults[]>(null as any);
    }
}

export class Active implements IActive {
    activeId?: number | undefined;
    name?: string | undefined;
    molecularWeight?: any | undefined;
    coreId?: number | undefined;
    bionexusId?: any | undefined;
    activeSuppliers?: any[] | undefined;
    activeIngredientCore?: any | undefined;

    constructor(data?: IActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeId = _data["activeId"];
            this.name = _data["name"];
            this.molecularWeight = _data["molecularWeight"];
            this.coreId = _data["coreId"];
            this.bionexusId = _data["bionexusId"];
            if (Array.isArray(_data["activeSuppliers"])) {
                this.activeSuppliers = [] as any;
                for (let item of _data["activeSuppliers"])
                    this.activeSuppliers.push(item);
            }
            this.activeIngredientCore = _data["activeIngredientCore"];
        }
    }

    static fromJS(data: any, _mappings?: any): Active | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Active>(data, _mappings, Active);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeId"] = this.activeId;
        data["name"] = this.name;
        data["molecularWeight"] = this.molecularWeight;
        data["coreId"] = this.coreId;
        data["bionexusId"] = this.bionexusId;
        if (Array.isArray(this.activeSuppliers)) {
            data["activeSuppliers"] = [];
            for (let item of this.activeSuppliers)
                data["activeSuppliers"].push(item);
        }
        data["activeIngredientCore"] = this.activeIngredientCore;
        return data;
    }
}

export interface IActive {
    activeId?: number | undefined;
    name?: string | undefined;
    molecularWeight?: any | undefined;
    coreId?: number | undefined;
    bionexusId?: any | undefined;
    activeSuppliers?: any[] | undefined;
    activeIngredientCore?: any | undefined;
}

export class ActiveIngredient implements IActiveIngredient {
    ingredientName?: string | undefined;
    concentrationPrimaryUom?: string | undefined;
    concentrationSecondaryUom?: string | undefined;

    constructor(data?: IActiveIngredient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ingredientName = _data["ingredientName"];
            this.concentrationPrimaryUom = _data["concentrationPrimaryUom"];
            this.concentrationSecondaryUom = _data["concentrationSecondaryUom"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveIngredient | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveIngredient>(data, _mappings, ActiveIngredient);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientName"] = this.ingredientName;
        data["concentrationPrimaryUom"] = this.concentrationPrimaryUom;
        data["concentrationSecondaryUom"] = this.concentrationSecondaryUom;
        return data;
    }
}

export interface IActiveIngredient {
    ingredientName?: string | undefined;
    concentrationPrimaryUom?: string | undefined;
    concentrationSecondaryUom?: string | undefined;
}

export class ActiveSupplier implements IActiveSupplier {
    activeId?: number | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;

    constructor(data?: IActiveSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeId = _data["activeId"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ActiveSupplier | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ActiveSupplier>(data, _mappings, ActiveSupplier);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeId"] = this.activeId;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        return data;
    }
}

export interface IActiveSupplier {
    activeId?: number | undefined;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
}

export class AlternateDto implements IAlternateDto {
    compositionId?: number | undefined;
    coformulantId?: string | undefined;
    alternateCoformulantId?: string | undefined;
    qualified?: any | undefined;
    lastUpdatedDate?: any | undefined;
    alternateCoformulantTradeName?: any | undefined;

    constructor(data?: IAlternateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.compositionId = _data["compositionId"];
            this.coformulantId = _data["coformulantId"];
            this.alternateCoformulantId = _data["alternateCoformulantId"];
            this.qualified = _data["qualified"];
            this.lastUpdatedDate = _data["lastUpdatedDate"];
            this.alternateCoformulantTradeName = _data["alternateCoformulantTradeName"];
        }
    }

    static fromJS(data: any, _mappings?: any): AlternateDto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<AlternateDto>(data, _mappings, AlternateDto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositionId"] = this.compositionId;
        data["coformulantId"] = this.coformulantId;
        data["alternateCoformulantId"] = this.alternateCoformulantId;
        data["qualified"] = this.qualified;
        data["lastUpdatedDate"] = this.lastUpdatedDate;
        data["alternateCoformulantTradeName"] = this.alternateCoformulantTradeName;
        return data;
    }
}

export interface IAlternateDto {
    compositionId?: number | undefined;
    coformulantId?: string | undefined;
    alternateCoformulantId?: string | undefined;
    qualified?: any | undefined;
    lastUpdatedDate?: any | undefined;
    alternateCoformulantTradeName?: any | undefined;
}

export class Approver implements IApprover {
    approverId?: number;
    fullName?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;

    constructor(data?: IApprover) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.approverId = _data["approverId"];
            this.fullName = _data["fullName"];
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): Approver | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Approver>(data, _mappings, Approver);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approverId"] = this.approverId;
        data["fullName"] = this.fullName;
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data;
    }
}

export interface IApprover {
    approverId?: number;
    fullName?: string | undefined;
    userId?: string | undefined;
    email?: string | undefined;
}

export class BatchSolvent implements IBatchSolvent {
    solvent?: string | undefined;
    batchId?: number | undefined;
    solventId?: number | undefined;
    percent?: number | undefined;
    batchSolventId?: number | undefined;

    constructor(data?: IBatchSolvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.solvent = _data["solvent"];
            this.batchId = _data["batchId"];
            this.solventId = _data["solventId"];
            this.percent = _data["percent"];
            this.batchSolventId = _data["batchSolventId"];
        }
    }

    static fromJS(data: any, _mappings?: any): BatchSolvent | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BatchSolvent>(data, _mappings, BatchSolvent);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["solvent"] = this.solvent;
        data["batchId"] = this.batchId;
        data["solventId"] = this.solventId;
        data["percent"] = this.percent;
        data["batchSolventId"] = this.batchSolventId;
        return data;
    }
}

export interface IBatchSolvent {
    solvent?: string | undefined;
    batchId?: number | undefined;
    solventId?: number | undefined;
    percent?: number | undefined;
    batchSolventId?: number | undefined;
}

export class BatchStorageCondition implements IBatchStorageCondition {
    batchId?: number | undefined;
    storageConditionId?: number | undefined;
    storageCondition?: string | undefined;

    constructor(data?: IBatchStorageCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.storageConditionId = _data["storageConditionId"];
            this.storageCondition = _data["storageCondition"];
        }
    }

    static fromJS(data: any, _mappings?: any): BatchStorageCondition | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BatchStorageCondition>(data, _mappings, BatchStorageCondition);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["storageConditionId"] = this.storageConditionId;
        data["storageCondition"] = this.storageCondition;
        return data;
    }
}

export interface IBatchStorageCondition {
    batchId?: number | undefined;
    storageConditionId?: number | undefined;
    storageCondition?: string | undefined;
}

export class BnxObjectAttribute implements IBnxObjectAttribute {
    attributeName?: string | undefined;
    bundleName?: string | undefined;
    values?: any[] | undefined;

    constructor(data?: IBnxObjectAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.attributeName = _data["attributeName"];
            this.bundleName = _data["bundleName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): BnxObjectAttribute | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<BnxObjectAttribute>(data, _mappings, BnxObjectAttribute);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeName"] = this.attributeName;
        data["bundleName"] = this.bundleName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IBnxObjectAttribute {
    attributeName?: string | undefined;
    bundleName?: string | undefined;
    values?: any[] | undefined;
}

export class CertificationStatusType implements ICertificationStatusType {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isactive?: boolean;

    constructor(data?: ICertificationStatusType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isactive = _data["isactive"];
        }
    }

    static fromJS(data: any, _mappings?: any): CertificationStatusType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CertificationStatusType>(data, _mappings, CertificationStatusType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isactive"] = this.isactive;
        return data;
    }
}

export interface ICertificationStatusType {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isactive?: boolean;
}

export class CompositeInventoryByLot implements ICompositeInventoryByLot {
    lotId?: number;
    lotNumber?: string | undefined;
    alchemistWarehouseId?: number | undefined;
    manufacturerLotNumber?: string | undefined;
    dateOfManufacture?: Date | undefined;
    expirationDate?: Date | undefined;
    isGlp?: boolean;
    glpStatus?: string | undefined;
    inventoryLocation?: string | undefined;
    inventoryType?: string | undefined;
    location?: string | undefined;
    physical?: number;
    reserved?: number;
    indyReserved?: number;
    sgsReserved?: number;
    franceReserved?: number;
    inProgress?: number;
    available?: number;
    isReach?: boolean | undefined;

    constructor(data?: ICompositeInventoryByLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.lotId = _data["lotId"];
            this.lotNumber = _data["lotNumber"];
            this.alchemistWarehouseId = _data["alchemistWarehouseId"];
            this.manufacturerLotNumber = _data["manufacturerLotNumber"];
            this.dateOfManufacture = _data["dateOfManufacture"] ? new Date(_data["dateOfManufacture"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.isGlp = _data["isGlp"];
            this.glpStatus = _data["glpStatus"];
            this.inventoryLocation = _data["inventoryLocation"];
            this.inventoryType = _data["inventoryType"];
            this.location = _data["location"];
            this.physical = _data["physical"];
            this.reserved = _data["reserved"];
            this.indyReserved = _data["indyReserved"];
            this.sgsReserved = _data["sgsReserved"];
            this.franceReserved = _data["franceReserved"];
            this.inProgress = _data["inProgress"];
            this.available = _data["available"];
            this.isReach = _data["isReach"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompositeInventoryByLot | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompositeInventoryByLot>(data, _mappings, CompositeInventoryByLot);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotId"] = this.lotId;
        data["lotNumber"] = this.lotNumber;
        data["alchemistWarehouseId"] = this.alchemistWarehouseId;
        data["manufacturerLotNumber"] = this.manufacturerLotNumber;
        data["dateOfManufacture"] = this.dateOfManufacture ? this.dateOfManufacture.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["isGlp"] = this.isGlp;
        data["glpStatus"] = this.glpStatus;
        data["inventoryLocation"] = this.inventoryLocation;
        data["inventoryType"] = this.inventoryType;
        data["location"] = this.location;
        data["physical"] = this.physical;
        data["reserved"] = this.reserved;
        data["indyReserved"] = this.indyReserved;
        data["sgsReserved"] = this.sgsReserved;
        data["franceReserved"] = this.franceReserved;
        data["inProgress"] = this.inProgress;
        data["available"] = this.available;
        data["isReach"] = this.isReach;
        return data;
    }
}

export interface ICompositeInventoryByLot {
    lotId?: number;
    lotNumber?: string | undefined;
    alchemistWarehouseId?: number | undefined;
    manufacturerLotNumber?: string | undefined;
    dateOfManufacture?: Date | undefined;
    expirationDate?: Date | undefined;
    isGlp?: boolean;
    glpStatus?: string | undefined;
    inventoryLocation?: string | undefined;
    inventoryType?: string | undefined;
    location?: string | undefined;
    physical?: number;
    reserved?: number;
    indyReserved?: number;
    sgsReserved?: number;
    franceReserved?: number;
    inProgress?: number;
    available?: number;
    isReach?: boolean | undefined;
}

export class CompositeInventoryResult implements ICompositeInventoryResult {
    materialId?: string | undefined;
    repoName?: string | undefined;
    uom?: string | undefined;
    totalPhysical?: number;
    totalReserved?: number;
    totalIndyReserved?: number;
    totalSGSReserved?: number;
    totalFranceReserved?: number;
    totalInProgress?: number;
    totalAvailable?: number;
    materialName?: string | undefined;
    compositeInventoryByLot?: CompositeInventoryByLot[] | undefined;

    constructor(data?: ICompositeInventoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.repoName = _data["repoName"];
            this.uom = _data["uom"];
            this.totalPhysical = _data["totalPhysical"];
            this.totalReserved = _data["totalReserved"];
            this.totalIndyReserved = _data["totalIndyReserved"];
            this.totalSGSReserved = _data["totalSGSReserved"];
            this.totalFranceReserved = _data["totalFranceReserved"];
            this.totalInProgress = _data["totalInProgress"];
            this.totalAvailable = _data["totalAvailable"];
            this.materialName = _data["materialName"];
            if (Array.isArray(_data["compositeInventoryByLot"])) {
                this.compositeInventoryByLot = [] as any;
                for (let item of _data["compositeInventoryByLot"])
                    this.compositeInventoryByLot.push(CompositeInventoryByLot.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompositeInventoryResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompositeInventoryResult>(data, _mappings, CompositeInventoryResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["repoName"] = this.repoName;
        data["uom"] = this.uom;
        data["totalPhysical"] = this.totalPhysical;
        data["totalReserved"] = this.totalReserved;
        data["totalIndyReserved"] = this.totalIndyReserved;
        data["totalSGSReserved"] = this.totalSGSReserved;
        data["totalFranceReserved"] = this.totalFranceReserved;
        data["totalInProgress"] = this.totalInProgress;
        data["totalAvailable"] = this.totalAvailable;
        data["materialName"] = this.materialName;
        if (Array.isArray(this.compositeInventoryByLot)) {
            data["compositeInventoryByLot"] = [];
            for (let item of this.compositeInventoryByLot)
                data["compositeInventoryByLot"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompositeInventoryResult {
    materialId?: string | undefined;
    repoName?: string | undefined;
    uom?: string | undefined;
    totalPhysical?: number;
    totalReserved?: number;
    totalIndyReserved?: number;
    totalSGSReserved?: number;
    totalFranceReserved?: number;
    totalInProgress?: number;
    totalAvailable?: number;
    materialName?: string | undefined;
    compositeInventoryByLot?: CompositeInventoryByLot[] | undefined;
}

export class CompositionActiveSupplier implements ICompositionActiveSupplier {
    activeId?: number | undefined;
    supplierId?: number | undefined;
    qualified?: boolean | undefined;
    supplierName?: string | undefined;

    constructor(data?: ICompositionActiveSupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeId = _data["activeId"];
            this.supplierId = _data["supplierId"];
            this.qualified = _data["qualified"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompositionActiveSupplier | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompositionActiveSupplier>(data, _mappings, CompositionActiveSupplier);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeId"] = this.activeId;
        data["supplierId"] = this.supplierId;
        data["qualified"] = this.qualified;
        data["supplierName"] = this.supplierName;
        return data;
    }
}

export interface ICompositionActiveSupplier {
    activeId?: number | undefined;
    supplierId?: number | undefined;
    qualified?: boolean | undefined;
    supplierName?: string | undefined;
}

export class CompoundLotDetail implements ICompoundLotDetail {
    lotId?: number | undefined;
    lotLabel?: string | undefined;
    purity?: string | undefined;
    domainId?: number | undefined;
    domain?: string | undefined;
    vendorLotId?: string | undefined;
    vendorCatalog?: string | undefined;
    stockAmount?: number | undefined;
    submittedAmount?: number | undefined;
    totalAmount?: number | undefined;
    lotType?: string | undefined;
    appearance?: string | undefined;
    vendorId?: number | undefined;
    vendorDisplay?: string | undefined;
    preparedById?: number | undefined;
    preparedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    certificationStatusType?: CertificationStatusType;
    certifiedStatus?: string | undefined;
    certifiedPurity?: number | undefined;
    certificationDate?: Date | undefined;
    recertificationDate?: Date | undefined;
    tsnNumber?: string | undefined;
    compoundId?: number | undefined;
    corpRegNumber?: string | undefined;
    lotNumber?: number | undefined;
    specificActivity?: number | undefined;
    initialStudyReference?: string | undefined;
    studyReference?: string | undefined;
    isPeroxideForming?: boolean;
    preparedBy?: string | undefined;
    enteredBy?: string | undefined;
    entryDate?: Date | undefined;
    molWeight?: number | undefined;
    shipmentApproverEmail?: string | undefined;
    compoundVersionView?: any;
    uses?: Us[] | undefined;
    projects?: Project[] | undefined;
    batchStorageConditions?: BatchStorageCondition[] | undefined;
    batchSolvents?: BatchSolvent[] | undefined;

    constructor(data?: ICompoundLotDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.lotId = _data["lotId"];
            this.lotLabel = _data["lotLabel"];
            this.purity = _data["purity"];
            this.domainId = _data["domainId"];
            this.domain = _data["domain"];
            this.vendorLotId = _data["vendorLotId"];
            this.vendorCatalog = _data["vendorCatalog"];
            this.stockAmount = _data["stockAmount"];
            this.submittedAmount = _data["submittedAmount"];
            this.totalAmount = _data["totalAmount"];
            this.lotType = _data["lotType"];
            this.appearance = _data["appearance"];
            this.vendorId = _data["vendorId"];
            this.vendorDisplay = _data["vendorDisplay"];
            this.preparedById = _data["preparedById"];
            this.preparedDate = _data["preparedDate"] ? new Date(_data["preparedDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.certificationStatusType = _data["certificationStatusType"] ? CertificationStatusType.fromJS(_data["certificationStatusType"], _mappings) : <any>undefined;
            this.certifiedStatus = _data["certifiedStatus"];
            this.certifiedPurity = _data["certifiedPurity"];
            this.certificationDate = _data["certificationDate"] ? new Date(_data["certificationDate"].toString()) : <any>undefined;
            this.recertificationDate = _data["recertificationDate"] ? new Date(_data["recertificationDate"].toString()) : <any>undefined;
            this.tsnNumber = _data["tsnNumber"];
            this.compoundId = _data["compoundId"];
            this.corpRegNumber = _data["corpRegNumber"];
            this.lotNumber = _data["lotNumber"];
            this.specificActivity = _data["specificActivity"];
            this.initialStudyReference = _data["initialStudyReference"];
            this.studyReference = _data["studyReference"];
            this.isPeroxideForming = _data["isPeroxideForming"];
            this.preparedBy = _data["preparedBy"];
            this.enteredBy = _data["enteredBy"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : <any>undefined;
            this.molWeight = _data["molWeight"];
            this.shipmentApproverEmail = _data["shipmentApproverEmail"];
            this.compoundVersionView = _data["compoundVersionView"];
            if (Array.isArray(_data["uses"])) {
                this.uses = [] as any;
                for (let item of _data["uses"])
                    this.uses.push(Us.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects.push(Project.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["batchStorageConditions"])) {
                this.batchStorageConditions = [] as any;
                for (let item of _data["batchStorageConditions"])
                    this.batchStorageConditions.push(BatchStorageCondition.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["batchSolvents"])) {
                this.batchSolvents = [] as any;
                for (let item of _data["batchSolvents"])
                    this.batchSolvents.push(BatchSolvent.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CompoundLotDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompoundLotDetail>(data, _mappings, CompoundLotDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotId"] = this.lotId;
        data["lotLabel"] = this.lotLabel;
        data["purity"] = this.purity;
        data["domainId"] = this.domainId;
        data["domain"] = this.domain;
        data["vendorLotId"] = this.vendorLotId;
        data["vendorCatalog"] = this.vendorCatalog;
        data["stockAmount"] = this.stockAmount;
        data["submittedAmount"] = this.submittedAmount;
        data["totalAmount"] = this.totalAmount;
        data["lotType"] = this.lotType;
        data["appearance"] = this.appearance;
        data["vendorId"] = this.vendorId;
        data["vendorDisplay"] = this.vendorDisplay;
        data["preparedById"] = this.preparedById;
        data["preparedDate"] = this.preparedDate ? this.preparedDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["certificationStatusType"] = this.certificationStatusType ? this.certificationStatusType.toJSON() : <any>undefined;
        data["certifiedStatus"] = this.certifiedStatus;
        data["certifiedPurity"] = this.certifiedPurity;
        data["certificationDate"] = this.certificationDate ? this.certificationDate.toISOString() : <any>undefined;
        data["recertificationDate"] = this.recertificationDate ? this.recertificationDate.toISOString() : <any>undefined;
        data["tsnNumber"] = this.tsnNumber;
        data["compoundId"] = this.compoundId;
        data["corpRegNumber"] = this.corpRegNumber;
        data["lotNumber"] = this.lotNumber;
        data["specificActivity"] = this.specificActivity;
        data["initialStudyReference"] = this.initialStudyReference;
        data["studyReference"] = this.studyReference;
        data["isPeroxideForming"] = this.isPeroxideForming;
        data["preparedBy"] = this.preparedBy;
        data["enteredBy"] = this.enteredBy;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["molWeight"] = this.molWeight;
        data["shipmentApproverEmail"] = this.shipmentApproverEmail;
        data["compoundVersionView"] = this.compoundVersionView;
        if (Array.isArray(this.uses)) {
            data["uses"] = [];
            for (let item of this.uses)
                data["uses"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.batchStorageConditions)) {
            data["batchStorageConditions"] = [];
            for (let item of this.batchStorageConditions)
                data["batchStorageConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.batchSolvents)) {
            data["batchSolvents"] = [];
            for (let item of this.batchSolvents)
                data["batchSolvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompoundLotDetail {
    lotId?: number | undefined;
    lotLabel?: string | undefined;
    purity?: string | undefined;
    domainId?: number | undefined;
    domain?: string | undefined;
    vendorLotId?: string | undefined;
    vendorCatalog?: string | undefined;
    stockAmount?: number | undefined;
    submittedAmount?: number | undefined;
    totalAmount?: number | undefined;
    lotType?: string | undefined;
    appearance?: string | undefined;
    vendorId?: number | undefined;
    vendorDisplay?: string | undefined;
    preparedById?: number | undefined;
    preparedDate?: Date | undefined;
    expirationDate?: Date | undefined;
    certificationStatusType?: CertificationStatusType;
    certifiedStatus?: string | undefined;
    certifiedPurity?: number | undefined;
    certificationDate?: Date | undefined;
    recertificationDate?: Date | undefined;
    tsnNumber?: string | undefined;
    compoundId?: number | undefined;
    corpRegNumber?: string | undefined;
    lotNumber?: number | undefined;
    specificActivity?: number | undefined;
    initialStudyReference?: string | undefined;
    studyReference?: string | undefined;
    isPeroxideForming?: boolean;
    preparedBy?: string | undefined;
    enteredBy?: string | undefined;
    entryDate?: Date | undefined;
    molWeight?: number | undefined;
    shipmentApproverEmail?: string | undefined;
    compoundVersionView?: any;
    uses?: Us[] | undefined;
    projects?: Project[] | undefined;
    batchStorageConditions?: BatchStorageCondition[] | undefined;
    batchSolvents?: BatchSolvent[] | undefined;
}

export class CompoundSynonymModel implements ICompoundSynonymModel {
    id?: number;
    value?: string | undefined;
    preparedDate?: string | undefined;
    enteredById?: string | undefined;
    entryDate?: string | undefined;
    modifiedById?: string | undefined;
    materialId?: number;
    synonymTypeId?: number;
    synonymType?: CompoundSynonymTypeModel;

    constructor(data?: ICompoundSynonymModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.preparedDate = _data["preparedDate"];
            this.enteredById = _data["enteredById"];
            this.entryDate = _data["entryDate"];
            this.modifiedById = _data["modifiedById"];
            this.materialId = _data["materialId"];
            this.synonymTypeId = _data["synonymTypeId"];
            this.synonymType = _data["synonymType"] ? CompoundSynonymTypeModel.fromJS(_data["synonymType"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): CompoundSynonymModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompoundSynonymModel>(data, _mappings, CompoundSynonymModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["preparedDate"] = this.preparedDate;
        data["enteredById"] = this.enteredById;
        data["entryDate"] = this.entryDate;
        data["modifiedById"] = this.modifiedById;
        data["materialId"] = this.materialId;
        data["synonymTypeId"] = this.synonymTypeId;
        data["synonymType"] = this.synonymType ? this.synonymType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompoundSynonymModel {
    id?: number;
    value?: string | undefined;
    preparedDate?: string | undefined;
    enteredById?: string | undefined;
    entryDate?: string | undefined;
    modifiedById?: string | undefined;
    materialId?: number;
    synonymTypeId?: number;
    synonymType?: CompoundSynonymTypeModel;
}

export class CompoundSynonymTypeModel implements ICompoundSynonymTypeModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isactive?: boolean;
    name?: string | undefined;

    constructor(data?: ICompoundSynonymTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.isactive = _data["isactive"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): CompoundSynonymTypeModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CompoundSynonymTypeModel>(data, _mappings, CompoundSynonymTypeModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["isactive"] = this.isactive;
        data["name"] = this.name;
        return data;
    }
}

export interface ICompoundSynonymTypeModel {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    isactive?: boolean;
    name?: string | undefined;
}

export class ConfidentialComposition implements IConfidentialComposition {
    compositionId?: number | undefined;
    name?: string | undefined;
    formulationConceptId?: number | undefined;
    version?: number | undefined;
    stage?: string | undefined;
    discontinued?: boolean;
    description?: string | undefined;
    density?: number | undefined;
    chemist?: string | undefined;
    createDate?: Date;
    leadCompositionDate?: any | undefined;
    leadChemist?: any | undefined;
    amp?: boolean;
    preferredSynonymId?: any | undefined;
    relatedParentId?: any | undefined;
    activePresence?: string | undefined;
    relatedParentName?: any | undefined;
    shelfLifeYears?: number | undefined;
    specificationNumber?: any | undefined;
    compositionName?: string | undefined;
    formulationConcept?: FormulationConcept;
    preferredSynonym?: Synonym;
    synonyms?: Synonym[] | undefined;
    lots?: ConfidentialCompositionLot[] | undefined;
    compositionActiveSuppliers?: CompositionActiveSupplier[] | undefined;
    compositionActiveOmittedDtos?: Dto[] | undefined;
    loading?: any | undefined;
    approver?: Approver;

    constructor(data?: IConfidentialComposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.compositionId = _data["compositionId"];
            this.name = _data["name"];
            this.formulationConceptId = _data["formulationConceptId"];
            this.version = _data["version"];
            this.stage = _data["stage"];
            this.discontinued = _data["discontinued"];
            this.description = _data["description"];
            this.density = _data["density"];
            this.chemist = _data["chemist"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.leadCompositionDate = _data["leadCompositionDate"];
            this.leadChemist = _data["leadChemist"];
            this.amp = _data["amp"];
            this.preferredSynonymId = _data["preferredSynonymId"];
            this.relatedParentId = _data["relatedParentId"];
            this.activePresence = _data["activePresence"];
            this.relatedParentName = _data["relatedParentName"];
            this.shelfLifeYears = _data["shelfLifeYears"];
            this.specificationNumber = _data["specificationNumber"];
            this.compositionName = _data["compositionName"];
            this.formulationConcept = _data["formulationConcept"] ? FormulationConcept.fromJS(_data["formulationConcept"], _mappings) : <any>undefined;
            this.preferredSynonym = _data["preferredSynonym"] ? Synonym.fromJS(_data["preferredSynonym"], _mappings) : <any>undefined;
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms.push(Synonym.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["lots"])) {
                this.lots = [] as any;
                for (let item of _data["lots"])
                    this.lots.push(ConfidentialCompositionLot.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["compositionActiveSuppliers"])) {
                this.compositionActiveSuppliers = [] as any;
                for (let item of _data["compositionActiveSuppliers"])
                    this.compositionActiveSuppliers.push(CompositionActiveSupplier.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["compositionActiveOmittedDtos"])) {
                this.compositionActiveOmittedDtos = [] as any;
                for (let item of _data["compositionActiveOmittedDtos"])
                    this.compositionActiveOmittedDtos.push(Dto.fromJS(item, _mappings));
            }
            this.loading = _data["loading"];
            this.approver = _data["approver"] ? Approver.fromJS(_data["approver"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ConfidentialComposition | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfidentialComposition>(data, _mappings, ConfidentialComposition);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositionId"] = this.compositionId;
        data["name"] = this.name;
        data["formulationConceptId"] = this.formulationConceptId;
        data["version"] = this.version;
        data["stage"] = this.stage;
        data["discontinued"] = this.discontinued;
        data["description"] = this.description;
        data["density"] = this.density;
        data["chemist"] = this.chemist;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["leadCompositionDate"] = this.leadCompositionDate;
        data["leadChemist"] = this.leadChemist;
        data["amp"] = this.amp;
        data["preferredSynonymId"] = this.preferredSynonymId;
        data["relatedParentId"] = this.relatedParentId;
        data["activePresence"] = this.activePresence;
        data["relatedParentName"] = this.relatedParentName;
        data["shelfLifeYears"] = this.shelfLifeYears;
        data["specificationNumber"] = this.specificationNumber;
        data["compositionName"] = this.compositionName;
        data["formulationConcept"] = this.formulationConcept ? this.formulationConcept.toJSON() : <any>undefined;
        data["preferredSynonym"] = this.preferredSynonym ? this.preferredSynonym.toJSON() : <any>undefined;
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item.toJSON());
        }
        if (Array.isArray(this.lots)) {
            data["lots"] = [];
            for (let item of this.lots)
                data["lots"].push(item.toJSON());
        }
        if (Array.isArray(this.compositionActiveSuppliers)) {
            data["compositionActiveSuppliers"] = [];
            for (let item of this.compositionActiveSuppliers)
                data["compositionActiveSuppliers"].push(item.toJSON());
        }
        if (Array.isArray(this.compositionActiveOmittedDtos)) {
            data["compositionActiveOmittedDtos"] = [];
            for (let item of this.compositionActiveOmittedDtos)
                data["compositionActiveOmittedDtos"].push(item.toJSON());
        }
        data["loading"] = this.loading;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfidentialComposition {
    compositionId?: number | undefined;
    name?: string | undefined;
    formulationConceptId?: number | undefined;
    version?: number | undefined;
    stage?: string | undefined;
    discontinued?: boolean;
    description?: string | undefined;
    density?: number | undefined;
    chemist?: string | undefined;
    createDate?: Date;
    leadCompositionDate?: any | undefined;
    leadChemist?: any | undefined;
    amp?: boolean;
    preferredSynonymId?: any | undefined;
    relatedParentId?: any | undefined;
    activePresence?: string | undefined;
    relatedParentName?: any | undefined;
    shelfLifeYears?: number | undefined;
    specificationNumber?: any | undefined;
    compositionName?: string | undefined;
    formulationConcept?: FormulationConcept;
    preferredSynonym?: Synonym;
    synonyms?: Synonym[] | undefined;
    lots?: ConfidentialCompositionLot[] | undefined;
    compositionActiveSuppliers?: CompositionActiveSupplier[] | undefined;
    compositionActiveOmittedDtos?: Dto[] | undefined;
    loading?: any | undefined;
    approver?: Approver;
}

export class ConfidentialCompositionLot implements IConfidentialCompositionLot {
    alternateDtos?: AlternateDto[] | undefined;
    componentDtos?: any[] | undefined;
    lotId?: number | undefined;
    lotNumber?: string | undefined;
    compositionLotNumber?: number | undefined;
    lotType?: any | undefined;
    compositionId?: number | undefined;
    preparer?: string | undefined;
    createDate?: Date;
    expirationDate?: Date | undefined;
    scale?: string | undefined;
    density?: number | undefined;
    reachApproved?: boolean;
    glpStatus?: string | undefined;
    comments?: any | undefined;
    stage?: string | undefined;
    formulationType?: any | undefined;
    manufacturerLotId?: string | undefined;
    glpCertificationDate?: any | undefined;
    glpRecertificationDate?: any | undefined;
    activeSupplierLots?: any[] | undefined;
    approver?: Approver;

    constructor(data?: IConfidentialCompositionLot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["alternateDtos"])) {
                this.alternateDtos = [] as any;
                for (let item of _data["alternateDtos"])
                    this.alternateDtos.push(AlternateDto.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["componentDtos"])) {
                this.componentDtos = [] as any;
                for (let item of _data["componentDtos"])
                    this.componentDtos.push(item);
            }
            this.lotId = _data["lotId"];
            this.lotNumber = _data["lotNumber"];
            this.compositionLotNumber = _data["compositionLotNumber"];
            this.lotType = _data["lotType"];
            this.compositionId = _data["compositionId"];
            this.preparer = _data["preparer"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.scale = _data["scale"];
            this.density = _data["density"];
            this.reachApproved = _data["reachApproved"];
            this.glpStatus = _data["glpStatus"];
            this.comments = _data["comments"];
            this.stage = _data["stage"];
            this.formulationType = _data["formulationType"];
            this.manufacturerLotId = _data["manufacturerLotId"];
            this.glpCertificationDate = _data["glpCertificationDate"];
            this.glpRecertificationDate = _data["glpRecertificationDate"];
            if (Array.isArray(_data["activeSupplierLots"])) {
                this.activeSupplierLots = [] as any;
                for (let item of _data["activeSupplierLots"])
                    this.activeSupplierLots.push(item);
            }
            this.approver = _data["approver"] ? Approver.fromJS(_data["approver"], _mappings) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): ConfidentialCompositionLot | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfidentialCompositionLot>(data, _mappings, ConfidentialCompositionLot);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alternateDtos)) {
            data["alternateDtos"] = [];
            for (let item of this.alternateDtos)
                data["alternateDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.componentDtos)) {
            data["componentDtos"] = [];
            for (let item of this.componentDtos)
                data["componentDtos"].push(item);
        }
        data["lotId"] = this.lotId;
        data["lotNumber"] = this.lotNumber;
        data["compositionLotNumber"] = this.compositionLotNumber;
        data["lotType"] = this.lotType;
        data["compositionId"] = this.compositionId;
        data["preparer"] = this.preparer;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["scale"] = this.scale;
        data["density"] = this.density;
        data["reachApproved"] = this.reachApproved;
        data["glpStatus"] = this.glpStatus;
        data["comments"] = this.comments;
        data["stage"] = this.stage;
        data["formulationType"] = this.formulationType;
        data["manufacturerLotId"] = this.manufacturerLotId;
        data["glpCertificationDate"] = this.glpCertificationDate;
        data["glpRecertificationDate"] = this.glpRecertificationDate;
        if (Array.isArray(this.activeSupplierLots)) {
            data["activeSupplierLots"] = [];
            for (let item of this.activeSupplierLots)
                data["activeSupplierLots"].push(item);
        }
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfidentialCompositionLot {
    alternateDtos?: AlternateDto[] | undefined;
    componentDtos?: any[] | undefined;
    lotId?: number | undefined;
    lotNumber?: string | undefined;
    compositionLotNumber?: number | undefined;
    lotType?: any | undefined;
    compositionId?: number | undefined;
    preparer?: string | undefined;
    createDate?: Date;
    expirationDate?: Date | undefined;
    scale?: string | undefined;
    density?: number | undefined;
    reachApproved?: boolean;
    glpStatus?: string | undefined;
    comments?: any | undefined;
    stage?: string | undefined;
    formulationType?: any | undefined;
    manufacturerLotId?: string | undefined;
    glpCertificationDate?: any | undefined;
    glpRecertificationDate?: any | undefined;
    activeSupplierLots?: any[] | undefined;
    approver?: Approver;
}

export class ConfidentialLotActive implements IConfidentialLotActive {
    activeName?: string | undefined;
    weightPct?: number;
    active?: ConfidentialLotActiveDetail;
    repo?: string | undefined;
    materialId?: string | undefined;

    constructor(data?: IConfidentialLotActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeName = _data["activeName"];
            this.weightPct = _data["weightPct"];
            this.active = _data["active"] ? ConfidentialLotActiveDetail.fromJS(_data["active"], _mappings) : <any>undefined;
            this.repo = _data["repo"];
            this.materialId = _data["materialId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfidentialLotActive | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfidentialLotActive>(data, _mappings, ConfidentialLotActive);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeName"] = this.activeName;
        data["weightPct"] = this.weightPct;
        data["active"] = this.active ? this.active.toJSON() : <any>undefined;
        data["repo"] = this.repo;
        data["materialId"] = this.materialId;
        return data;
    }
}

export interface IConfidentialLotActive {
    activeName?: string | undefined;
    weightPct?: number;
    active?: ConfidentialLotActiveDetail;
    repo?: string | undefined;
    materialId?: string | undefined;
}

export class ConfidentialLotActiveDetail implements IConfidentialLotActiveDetail {
    coreId?: string | undefined;
    bionexusId?: string | undefined;

    constructor(data?: IConfidentialLotActiveDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.coreId = _data["coreId"];
            this.bionexusId = _data["bionexusId"];
        }
    }

    static fromJS(data: any, _mappings?: any): ConfidentialLotActiveDetail | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfidentialLotActiveDetail>(data, _mappings, ConfidentialLotActiveDetail);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coreId"] = this.coreId;
        data["bionexusId"] = this.bionexusId;
        return data;
    }
}

export interface IConfidentialLotActiveDetail {
    coreId?: string | undefined;
    bionexusId?: string | undefined;
}

export class ConfidentialLotCompositionModel implements IConfidentialLotCompositionModel {
    actives?: ConfidentialLotActive[] | undefined;

    constructor(data?: IConfidentialLotCompositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["actives"])) {
                this.actives = [] as any;
                for (let item of _data["actives"])
                    this.actives.push(ConfidentialLotActive.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ConfidentialLotCompositionModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ConfidentialLotCompositionModel>(data, _mappings, ConfidentialLotCompositionModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actives)) {
            data["actives"] = [];
            for (let item of this.actives)
                data["actives"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConfidentialLotCompositionModel {
    actives?: ConfidentialLotActive[] | undefined;
}

export class CountryLabel implements ICountryLabel {
    country?: string | undefined;
    labels?: string[] | undefined;

    constructor(data?: ICountryLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.country = _data["country"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): CountryLabel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<CountryLabel>(data, _mappings, CountryLabel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        return data;
    }
}

export interface ICountryLabel {
    country?: string | undefined;
    labels?: string[] | undefined;
}

export class DocumentCopyRequest implements IDocumentCopyRequest {
    referenceID: string;

    constructor(data?: IDocumentCopyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.referenceID = _data["referenceID"];
        }
    }

    static fromJS(data: any, _mappings?: any): DocumentCopyRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DocumentCopyRequest>(data, _mappings, DocumentCopyRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceID"] = this.referenceID;
        return data;
    }
}

export interface IDocumentCopyRequest {
    referenceID: string;
}

export class DocumentCreateRequest implements IDocumentCreateRequest {
    documentTypeID: number;
    referenceID: string;
    originalFilename: string;
    comments?: string | undefined;
    languageID?: number | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    base64FileContents: string;

    constructor(data?: IDocumentCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.documentTypeID = _data["documentTypeID"];
            this.referenceID = _data["referenceID"];
            this.originalFilename = _data["originalFilename"];
            this.comments = _data["comments"];
            this.languageID = _data["languageID"];
            this.productSourceSystem = _data["productSourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.productLotNumber = _data["productLotNumber"];
            this.base64FileContents = _data["base64FileContents"];
        }
    }

    static fromJS(data: any, _mappings?: any): DocumentCreateRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DocumentCreateRequest>(data, _mappings, DocumentCreateRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeID"] = this.documentTypeID;
        data["referenceID"] = this.referenceID;
        data["originalFilename"] = this.originalFilename;
        data["comments"] = this.comments;
        data["languageID"] = this.languageID;
        data["productSourceSystem"] = this.productSourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["productLotNumber"] = this.productLotNumber;
        data["base64FileContents"] = this.base64FileContents;
        return data;
    }
}

export interface IDocumentCreateRequest {
    documentTypeID: number;
    referenceID: string;
    originalFilename: string;
    comments?: string | undefined;
    languageID?: number | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    base64FileContents: string;
}

export class DocumentResponse implements IDocumentResponse {
    documentID?: string;
    documentTypeID?: number;
    referenceID?: string | undefined;
    originalFilename?: string | undefined;
    comments?: string | undefined;
    languageID?: number | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    azureFilename?: string | undefined;
    isHidden?: boolean | undefined;
    created?: Date;
    updated?: Date | undefined;
    documentTypeName?: string | undefined;
    base64FileContents?: string | undefined;
    languageName?: string | undefined;

    constructor(data?: IDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.documentID = _data["documentID"];
            this.documentTypeID = _data["documentTypeID"];
            this.referenceID = _data["referenceID"];
            this.originalFilename = _data["originalFilename"];
            this.comments = _data["comments"];
            this.languageID = _data["languageID"];
            this.productSourceSystem = _data["productSourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.productLotNumber = _data["productLotNumber"];
            this.azureFilename = _data["azureFilename"];
            this.isHidden = _data["isHidden"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.documentTypeName = _data["documentTypeName"];
            this.base64FileContents = _data["base64FileContents"];
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any, _mappings?: any): DocumentResponse | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DocumentResponse>(data, _mappings, DocumentResponse);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentID"] = this.documentID;
        data["documentTypeID"] = this.documentTypeID;
        data["referenceID"] = this.referenceID;
        data["originalFilename"] = this.originalFilename;
        data["comments"] = this.comments;
        data["languageID"] = this.languageID;
        data["productSourceSystem"] = this.productSourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["productLotNumber"] = this.productLotNumber;
        data["azureFilename"] = this.azureFilename;
        data["isHidden"] = this.isHidden;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["documentTypeName"] = this.documentTypeName;
        data["base64FileContents"] = this.base64FileContents;
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IDocumentResponse {
    documentID?: string;
    documentTypeID?: number;
    referenceID?: string | undefined;
    originalFilename?: string | undefined;
    comments?: string | undefined;
    languageID?: number | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    azureFilename?: string | undefined;
    isHidden?: boolean | undefined;
    created?: Date;
    updated?: Date | undefined;
    documentTypeName?: string | undefined;
    base64FileContents?: string | undefined;
    languageName?: string | undefined;
}

export class DocumentType implements IDocumentType {
    documentTypeID?: number;
    name?: string | undefined;

    constructor(data?: IDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.documentTypeID = _data["documentTypeID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): DocumentType | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DocumentType>(data, _mappings, DocumentType);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeID"] = this.documentTypeID;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentType {
    documentTypeID?: number;
    name?: string | undefined;
}

export class DocumentUpdateRequest implements IDocumentUpdateRequest {
    documentTypeID?: number | undefined;
    referenceID?: string | undefined;
    languageID?: number | undefined;
    comments?: string | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    isHidden?: boolean | undefined;

    constructor(data?: IDocumentUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.documentTypeID = _data["documentTypeID"];
            this.referenceID = _data["referenceID"];
            this.languageID = _data["languageID"];
            this.comments = _data["comments"];
            this.productSourceSystem = _data["productSourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.productLotNumber = _data["productLotNumber"];
            this.isHidden = _data["isHidden"];
        }
    }

    static fromJS(data: any, _mappings?: any): DocumentUpdateRequest | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<DocumentUpdateRequest>(data, _mappings, DocumentUpdateRequest);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentTypeID"] = this.documentTypeID;
        data["referenceID"] = this.referenceID;
        data["languageID"] = this.languageID;
        data["comments"] = this.comments;
        data["productSourceSystem"] = this.productSourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["productLotNumber"] = this.productLotNumber;
        data["isHidden"] = this.isHidden;
        return data;
    }
}

export interface IDocumentUpdateRequest {
    documentTypeID?: number | undefined;
    referenceID?: string | undefined;
    languageID?: number | undefined;
    comments?: string | undefined;
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    productLotNumber?: string | undefined;
    isHidden?: boolean | undefined;
}

export class Dto implements IDto {
    activeId?: number | undefined;
    compositionId?: number | undefined;
    formulationConceptId?: number | undefined;

    constructor(data?: IDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.activeId = _data["activeId"];
            this.compositionId = _data["compositionId"];
            this.formulationConceptId = _data["formulationConceptId"];
        }
    }

    static fromJS(data: any, _mappings?: any): Dto | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Dto>(data, _mappings, Dto);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeId"] = this.activeId;
        data["compositionId"] = this.compositionId;
        data["formulationConceptId"] = this.formulationConceptId;
        return data;
    }
}

export interface IDto {
    activeId?: number | undefined;
    compositionId?: number | undefined;
    formulationConceptId?: number | undefined;
}

export class FormulationConcept implements IFormulationConcept {
    formulationConceptId?: number | undefined;
    name?: string | undefined;
    aiCode?: string | undefined;
    variantNumber?: number | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeCode?: string | undefined;
    formulationTypeDescription?: string | undefined;
    formulationTypeMaterialState?: string | undefined;
    formulationStage?: any | undefined;
    comment?: any | undefined;
    thirdParty?: boolean;
    formulationConceptActives?: FormulationConceptActive[] | undefined;

    constructor(data?: IFormulationConcept) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.formulationConceptId = _data["formulationConceptId"];
            this.name = _data["name"];
            this.aiCode = _data["aiCode"];
            this.variantNumber = _data["variantNumber"];
            this.formulationTypeId = _data["formulationTypeId"];
            this.formulationTypeCode = _data["formulationTypeCode"];
            this.formulationTypeDescription = _data["formulationTypeDescription"];
            this.formulationTypeMaterialState = _data["formulationTypeMaterialState"];
            this.formulationStage = _data["formulationStage"];
            this.comment = _data["comment"];
            this.thirdParty = _data["thirdParty"];
            if (Array.isArray(_data["formulationConceptActives"])) {
                this.formulationConceptActives = [] as any;
                for (let item of _data["formulationConceptActives"])
                    this.formulationConceptActives.push(FormulationConceptActive.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FormulationConcept | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FormulationConcept>(data, _mappings, FormulationConcept);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulationConceptId"] = this.formulationConceptId;
        data["name"] = this.name;
        data["aiCode"] = this.aiCode;
        data["variantNumber"] = this.variantNumber;
        data["formulationTypeId"] = this.formulationTypeId;
        data["formulationTypeCode"] = this.formulationTypeCode;
        data["formulationTypeDescription"] = this.formulationTypeDescription;
        data["formulationTypeMaterialState"] = this.formulationTypeMaterialState;
        data["formulationStage"] = this.formulationStage;
        data["comment"] = this.comment;
        data["thirdParty"] = this.thirdParty;
        if (Array.isArray(this.formulationConceptActives)) {
            data["formulationConceptActives"] = [];
            for (let item of this.formulationConceptActives)
                data["formulationConceptActives"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormulationConcept {
    formulationConceptId?: number | undefined;
    name?: string | undefined;
    aiCode?: string | undefined;
    variantNumber?: number | undefined;
    formulationTypeId?: number | undefined;
    formulationTypeCode?: string | undefined;
    formulationTypeDescription?: string | undefined;
    formulationTypeMaterialState?: string | undefined;
    formulationStage?: any | undefined;
    comment?: any | undefined;
    thirdParty?: boolean;
    formulationConceptActives?: FormulationConceptActive[] | undefined;
}

export class FormulationConceptActive implements IFormulationConceptActive {
    formulationConceptId?: number | undefined;
    activeId?: number | undefined;
    activeName?: string | undefined;
    loading?: number;
    units?: string | undefined;
    useAeIpr?: boolean;
    reactantWeightPercentage?: any | undefined;
    active?: Active;
    activeSuppliers?: ActiveSupplier[] | undefined;

    constructor(data?: IFormulationConceptActive) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.formulationConceptId = _data["formulationConceptId"];
            this.activeId = _data["activeId"];
            this.activeName = _data["activeName"];
            this.loading = _data["loading"];
            this.units = _data["units"];
            this.useAeIpr = _data["useAeIpr"];
            this.reactantWeightPercentage = _data["reactantWeightPercentage"];
            this.active = _data["active"] ? Active.fromJS(_data["active"], _mappings) : <any>undefined;
            if (Array.isArray(_data["activeSuppliers"])) {
                this.activeSuppliers = [] as any;
                for (let item of _data["activeSuppliers"])
                    this.activeSuppliers.push(ActiveSupplier.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): FormulationConceptActive | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<FormulationConceptActive>(data, _mappings, FormulationConceptActive);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formulationConceptId"] = this.formulationConceptId;
        data["activeId"] = this.activeId;
        data["activeName"] = this.activeName;
        data["loading"] = this.loading;
        data["units"] = this.units;
        data["useAeIpr"] = this.useAeIpr;
        data["reactantWeightPercentage"] = this.reactantWeightPercentage;
        data["active"] = this.active ? this.active.toJSON() : <any>undefined;
        if (Array.isArray(this.activeSuppliers)) {
            data["activeSuppliers"] = [];
            for (let item of this.activeSuppliers)
                data["activeSuppliers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormulationConceptActive {
    formulationConceptId?: number | undefined;
    activeId?: number | undefined;
    activeName?: string | undefined;
    loading?: number;
    units?: string | undefined;
    useAeIpr?: boolean;
    reactantWeightPercentage?: any | undefined;
    active?: Active;
    activeSuppliers?: ActiveSupplier[] | undefined;
}

export class IngredientAttribute implements IIngredientAttribute {
    values?: any[] | undefined;
    name?: string | undefined;
    dataType?: string | undefined;

    constructor(data?: IIngredientAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(item);
            }
            this.name = _data["name"];
            this.dataType = _data["dataType"];
        }
    }

    static fromJS(data: any, _mappings?: any): IngredientAttribute | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IngredientAttribute>(data, _mappings, IngredientAttribute);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        return data;
    }
}

export interface IIngredientAttribute {
    values?: any[] | undefined;
    name?: string | undefined;
    dataType?: string | undefined;
}

export class IngredientLotBio implements IIngredientLotBio {
    ingredientLotId?: number;
    externalId?: string | undefined;
    ingredientId?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date;
    attributes?: BnxObjectAttribute[] | undefined;

    constructor(data?: IIngredientLotBio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.ingredientLotId = _data["ingredientLotId"];
            this.externalId = _data["externalId"];
            this.ingredientId = _data["ingredientId"];
            this.isActive = _data["isActive"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes.push(BnxObjectAttribute.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): IngredientLotBio | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<IngredientLotBio>(data, _mappings, IngredientLotBio);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingredientLotId"] = this.ingredientLotId;
        data["externalId"] = this.externalId;
        data["ingredientId"] = this.ingredientId;
        data["isActive"] = this.isActive;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIngredientLotBio {
    ingredientLotId?: number;
    externalId?: string | undefined;
    ingredientId?: number;
    isActive?: boolean;
    createdBy?: string | undefined;
    createdDate?: Date;
    modifiedBy?: string | undefined;
    modifiedDate?: Date;
    attributes?: BnxObjectAttribute[] | undefined;
}

export class Language implements ILanguage {
    languageID?: number;
    name?: string | undefined;
    isDefault?: boolean;
    sortOrder?: number;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.languageID = _data["languageID"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any, _mappings?: any): Language | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Language>(data, _mappings, Language);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageID"] = this.languageID;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ILanguage {
    languageID?: number;
    name?: string | undefined;
    isDefault?: boolean;
    sortOrder?: number;
}

export class MaterialModel implements IMaterialModel {
    disciplineId?: number | undefined;
    discipline?: string | undefined;
    materialId?: number | undefined;
    materialName?: string | undefined;
    materialTypeId?: number | undefined;
    materialTypeName?: string | undefined;
    offerCode?: string | undefined;
    enteredById?: string | undefined;
    enteredByName?: string | undefined;
    entryDate?: string | undefined;
    preparedByName?: string | undefined;
    preparedDate?: string | undefined;
    shipmentApproverEmail?: string | undefined;
    compoundSynonyms?: CompoundSynonymModel[] | undefined;
    compoundLots?: CompoundLotDetail[] | undefined;

    constructor(data?: IMaterialModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.disciplineId = _data["disciplineId"];
            this.discipline = _data["discipline"];
            this.materialId = _data["materialId"];
            this.materialName = _data["materialName"];
            this.materialTypeId = _data["materialTypeId"];
            this.materialTypeName = _data["materialTypeName"];
            this.offerCode = _data["offerCode"];
            this.enteredById = _data["enteredById"];
            this.enteredByName = _data["enteredByName"];
            this.entryDate = _data["entryDate"];
            this.preparedByName = _data["preparedByName"];
            this.preparedDate = _data["preparedDate"];
            this.shipmentApproverEmail = _data["shipmentApproverEmail"];
            if (Array.isArray(_data["compoundSynonyms"])) {
                this.compoundSynonyms = [] as any;
                for (let item of _data["compoundSynonyms"])
                    this.compoundSynonyms.push(CompoundSynonymModel.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["compoundLots"])) {
                this.compoundLots = [] as any;
                for (let item of _data["compoundLots"])
                    this.compoundLots.push(CompoundLotDetail.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialModel>(data, _mappings, MaterialModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disciplineId"] = this.disciplineId;
        data["discipline"] = this.discipline;
        data["materialId"] = this.materialId;
        data["materialName"] = this.materialName;
        data["materialTypeId"] = this.materialTypeId;
        data["materialTypeName"] = this.materialTypeName;
        data["offerCode"] = this.offerCode;
        data["enteredById"] = this.enteredById;
        data["enteredByName"] = this.enteredByName;
        data["entryDate"] = this.entryDate;
        data["preparedByName"] = this.preparedByName;
        data["preparedDate"] = this.preparedDate;
        data["shipmentApproverEmail"] = this.shipmentApproverEmail;
        if (Array.isArray(this.compoundSynonyms)) {
            data["compoundSynonyms"] = [];
            for (let item of this.compoundSynonyms)
                data["compoundSynonyms"].push(item.toJSON());
        }
        if (Array.isArray(this.compoundLots)) {
            data["compoundLots"] = [];
            for (let item of this.compoundLots)
                data["compoundLots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialModel {
    disciplineId?: number | undefined;
    discipline?: string | undefined;
    materialId?: number | undefined;
    materialName?: string | undefined;
    materialTypeId?: number | undefined;
    materialTypeName?: string | undefined;
    offerCode?: string | undefined;
    enteredById?: string | undefined;
    enteredByName?: string | undefined;
    entryDate?: string | undefined;
    preparedByName?: string | undefined;
    preparedDate?: string | undefined;
    shipmentApproverEmail?: string | undefined;
    compoundSynonyms?: CompoundSynonymModel[] | undefined;
    compoundLots?: CompoundLotDetail[] | undefined;
}

export class MaterialResult implements IMaterialResult {
    materialCategory?: string | undefined;
    materialSearchType?: string | undefined;
    sourceSystem?: string | undefined;
    materialName?: string | undefined;
    materialIdInTargetSystem?: string | undefined;
    tradeName?: string | undefined;
    commonName?: string | undefined;
    brandName?: string | undefined;
    iupacName?: string | undefined;
    formulationId?: string | undefined;
    materialId?: string | undefined;
    certifiedPurity?: number | undefined;
    stage?: string | undefined;
    formulationTypeCode?: string | undefined;
    formulationTypeDesc?: string | undefined;
    isGLP?: boolean;
    isThirdParty?: boolean;
    isReachCompliant?: boolean;
    actives?: ActiveIngredient[] | undefined;
    synonyms?: string[] | undefined;
    preferredSynonym?: string | undefined;
    sampleUse?: string | undefined;
    glpStatus?: string | undefined;
    tsn?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    purity?: number | undefined;
    quantity?: number | undefined;
    quantityUom?: string | undefined;
    approverEmail?: string | undefined;
    approverFullName?: string | undefined;
    certificationDate?: Date | undefined;
    recertificationDate?: Date | undefined;
    discontinued?: boolean;
    isBioFormulation?: boolean;
    status?: string | undefined;
    materialAttributes?: IngredientAttribute[] | undefined;
    lotAttributes?: IngredientAttribute[] | undefined;
    ingredientId?: string | undefined;
    ingredientLots?: IngredientLotBio[] | undefined;

    constructor(data?: IMaterialResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.materialCategory = _data["materialCategory"];
            this.materialSearchType = _data["materialSearchType"];
            this.sourceSystem = _data["sourceSystem"];
            this.materialName = _data["materialName"];
            this.materialIdInTargetSystem = _data["materialIdInTargetSystem"];
            this.tradeName = _data["tradeName"];
            this.commonName = _data["commonName"];
            this.brandName = _data["brandName"];
            this.iupacName = _data["iupacName"];
            this.formulationId = _data["formulationId"];
            this.materialId = _data["materialId"];
            this.certifiedPurity = _data["certifiedPurity"];
            this.stage = _data["stage"];
            this.formulationTypeCode = _data["formulationTypeCode"];
            this.formulationTypeDesc = _data["formulationTypeDesc"];
            this.isGLP = _data["isGLP"];
            this.isThirdParty = _data["isThirdParty"];
            this.isReachCompliant = _data["isReachCompliant"];
            if (Array.isArray(_data["actives"])) {
                this.actives = [] as any;
                for (let item of _data["actives"])
                    this.actives.push(ActiveIngredient.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["synonyms"])) {
                this.synonyms = [] as any;
                for (let item of _data["synonyms"])
                    this.synonyms.push(item);
            }
            this.preferredSynonym = _data["preferredSynonym"];
            this.sampleUse = _data["sampleUse"];
            this.glpStatus = _data["glpStatus"];
            this.tsn = _data["tsn"];
            this.lotId = _data["lotId"];
            this.lotNumber = _data["lotNumber"];
            this.purity = _data["purity"];
            this.quantity = _data["quantity"];
            this.quantityUom = _data["quantityUom"];
            this.approverEmail = _data["approverEmail"];
            this.approverFullName = _data["approverFullName"];
            this.certificationDate = _data["certificationDate"] ? new Date(_data["certificationDate"].toString()) : <any>undefined;
            this.recertificationDate = _data["recertificationDate"] ? new Date(_data["recertificationDate"].toString()) : <any>undefined;
            this.discontinued = _data["discontinued"];
            this.isBioFormulation = _data["isBioFormulation"];
            this.status = _data["status"];
            if (Array.isArray(_data["materialAttributes"])) {
                this.materialAttributes = [] as any;
                for (let item of _data["materialAttributes"])
                    this.materialAttributes.push(IngredientAttribute.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["lotAttributes"])) {
                this.lotAttributes = [] as any;
                for (let item of _data["lotAttributes"])
                    this.lotAttributes.push(IngredientAttribute.fromJS(item, _mappings));
            }
            this.ingredientId = _data["ingredientId"];
            if (Array.isArray(_data["ingredientLots"])) {
                this.ingredientLots = [] as any;
                for (let item of _data["ingredientLots"])
                    this.ingredientLots.push(IngredientLotBio.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): MaterialResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<MaterialResult>(data, _mappings, MaterialResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialCategory"] = this.materialCategory;
        data["materialSearchType"] = this.materialSearchType;
        data["sourceSystem"] = this.sourceSystem;
        data["materialName"] = this.materialName;
        data["materialIdInTargetSystem"] = this.materialIdInTargetSystem;
        data["tradeName"] = this.tradeName;
        data["commonName"] = this.commonName;
        data["brandName"] = this.brandName;
        data["iupacName"] = this.iupacName;
        data["formulationId"] = this.formulationId;
        data["materialId"] = this.materialId;
        data["certifiedPurity"] = this.certifiedPurity;
        data["stage"] = this.stage;
        data["formulationTypeCode"] = this.formulationTypeCode;
        data["formulationTypeDesc"] = this.formulationTypeDesc;
        data["isGLP"] = this.isGLP;
        data["isThirdParty"] = this.isThirdParty;
        data["isReachCompliant"] = this.isReachCompliant;
        if (Array.isArray(this.actives)) {
            data["actives"] = [];
            for (let item of this.actives)
                data["actives"].push(item.toJSON());
        }
        if (Array.isArray(this.synonyms)) {
            data["synonyms"] = [];
            for (let item of this.synonyms)
                data["synonyms"].push(item);
        }
        data["preferredSynonym"] = this.preferredSynonym;
        data["sampleUse"] = this.sampleUse;
        data["glpStatus"] = this.glpStatus;
        data["tsn"] = this.tsn;
        data["lotId"] = this.lotId;
        data["lotNumber"] = this.lotNumber;
        data["purity"] = this.purity;
        data["quantity"] = this.quantity;
        data["quantityUom"] = this.quantityUom;
        data["approverEmail"] = this.approverEmail;
        data["approverFullName"] = this.approverFullName;
        data["certificationDate"] = this.certificationDate ? this.certificationDate.toISOString() : <any>undefined;
        data["recertificationDate"] = this.recertificationDate ? this.recertificationDate.toISOString() : <any>undefined;
        data["discontinued"] = this.discontinued;
        data["isBioFormulation"] = this.isBioFormulation;
        data["status"] = this.status;
        if (Array.isArray(this.materialAttributes)) {
            data["materialAttributes"] = [];
            for (let item of this.materialAttributes)
                data["materialAttributes"].push(item.toJSON());
        }
        if (Array.isArray(this.lotAttributes)) {
            data["lotAttributes"] = [];
            for (let item of this.lotAttributes)
                data["lotAttributes"].push(item.toJSON());
        }
        data["ingredientId"] = this.ingredientId;
        if (Array.isArray(this.ingredientLots)) {
            data["ingredientLots"] = [];
            for (let item of this.ingredientLots)
                data["ingredientLots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaterialResult {
    materialCategory?: string | undefined;
    materialSearchType?: string | undefined;
    sourceSystem?: string | undefined;
    materialName?: string | undefined;
    materialIdInTargetSystem?: string | undefined;
    tradeName?: string | undefined;
    commonName?: string | undefined;
    brandName?: string | undefined;
    iupacName?: string | undefined;
    formulationId?: string | undefined;
    materialId?: string | undefined;
    certifiedPurity?: number | undefined;
    stage?: string | undefined;
    formulationTypeCode?: string | undefined;
    formulationTypeDesc?: string | undefined;
    isGLP?: boolean;
    isThirdParty?: boolean;
    isReachCompliant?: boolean;
    actives?: ActiveIngredient[] | undefined;
    synonyms?: string[] | undefined;
    preferredSynonym?: string | undefined;
    sampleUse?: string | undefined;
    glpStatus?: string | undefined;
    tsn?: string | undefined;
    lotId?: string | undefined;
    lotNumber?: string | undefined;
    purity?: number | undefined;
    quantity?: number | undefined;
    quantityUom?: string | undefined;
    approverEmail?: string | undefined;
    approverFullName?: string | undefined;
    certificationDate?: Date | undefined;
    recertificationDate?: Date | undefined;
    discontinued?: boolean;
    isBioFormulation?: boolean;
    status?: string | undefined;
    materialAttributes?: IngredientAttribute[] | undefined;
    lotAttributes?: IngredientAttribute[] | undefined;
    ingredientId?: string | undefined;
    ingredientLots?: IngredientLotBio[] | undefined;
}

export class PartnerOutRecord implements IPartnerOutRecord {
    partnerId?: string | undefined;
    orgCode?: string | undefined;
    companyCode?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;
    fax?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    embargoHold?: string | undefined;
    customEmbargoMatch?: string | undefined;
    status?: string | undefined;
    decisionBy?: string | undefined;
    screenedDate?: string | undefined;
    integrationStatus?: PartnerRecordIntegrationStatus[] | undefined;

    constructor(data?: IPartnerOutRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.orgCode = _data["orgCode"];
            this.companyCode = _data["companyCode"];
            this.name = _data["name"];
            this.primaryContact = _data["primaryContact"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.address4 = _data["address4"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.country = _data["country"];
            this.fax = _data["fax"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.embargoHold = _data["embargoHold"];
            this.customEmbargoMatch = _data["customEmbargoMatch"];
            this.status = _data["status"];
            this.decisionBy = _data["decisionBy"];
            this.screenedDate = _data["screenedDate"];
            if (Array.isArray(_data["integrationStatus"])) {
                this.integrationStatus = [] as any;
                for (let item of _data["integrationStatus"])
                    this.integrationStatus.push(PartnerRecordIntegrationStatus.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): PartnerOutRecord | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PartnerOutRecord>(data, _mappings, PartnerOutRecord);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["orgCode"] = this.orgCode;
        data["companyCode"] = this.companyCode;
        data["name"] = this.name;
        data["primaryContact"] = this.primaryContact;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["address4"] = this.address4;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["country"] = this.country;
        data["fax"] = this.fax;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["embargoHold"] = this.embargoHold;
        data["customEmbargoMatch"] = this.customEmbargoMatch;
        data["status"] = this.status;
        data["decisionBy"] = this.decisionBy;
        data["screenedDate"] = this.screenedDate;
        if (Array.isArray(this.integrationStatus)) {
            data["integrationStatus"] = [];
            for (let item of this.integrationStatus)
                data["integrationStatus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartnerOutRecord {
    partnerId?: string | undefined;
    orgCode?: string | undefined;
    companyCode?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    countryCode?: string | undefined;
    country?: string | undefined;
    fax?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    embargoHold?: string | undefined;
    customEmbargoMatch?: string | undefined;
    status?: string | undefined;
    decisionBy?: string | undefined;
    screenedDate?: string | undefined;
    integrationStatus?: PartnerRecordIntegrationStatus[] | undefined;
}

export class PartnerRecordIntegrationStatus implements IPartnerRecordIntegrationStatus {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;

    constructor(data?: IPartnerRecordIntegrationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): PartnerRecordIntegrationStatus | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PartnerRecordIntegrationStatus>(data, _mappings, PartnerRecordIntegrationStatus);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        return data;
    }
}

export interface IPartnerRecordIntegrationStatus {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
}

export class PartnerResult implements IPartnerResult {
    partnerId?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    embargoHold?: boolean | undefined;
    customEmbargoMatch?: boolean | undefined;
    matchStatus?: boolean | undefined;
    screenedDate?: Date;

    constructor(data?: IPartnerResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.name = _data["name"];
            this.primaryContact = _data["primaryContact"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.address4 = _data["address4"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.embargoHold = _data["embargoHold"];
            this.customEmbargoMatch = _data["customEmbargoMatch"];
            this.matchStatus = _data["matchStatus"];
            this.screenedDate = _data["screenedDate"] ? new Date(_data["screenedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any, _mappings?: any): PartnerResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PartnerResult>(data, _mappings, PartnerResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["name"] = this.name;
        data["primaryContact"] = this.primaryContact;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["address4"] = this.address4;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["embargoHold"] = this.embargoHold;
        data["customEmbargoMatch"] = this.customEmbargoMatch;
        data["matchStatus"] = this.matchStatus;
        data["screenedDate"] = this.screenedDate ? this.screenedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPartnerResult {
    partnerId?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    embargoHold?: boolean | undefined;
    customEmbargoMatch?: boolean | undefined;
    matchStatus?: boolean | undefined;
    screenedDate?: Date;
}

export class PartnerSearch implements IPartnerSearch {
    partnerId?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPartnerSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.name = _data["name"];
            this.primaryContact = _data["primaryContact"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.address4 = _data["address4"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any, _mappings?: any): PartnerSearch | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<PartnerSearch>(data, _mappings, PartnerSearch);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["name"] = this.name;
        data["primaryContact"] = this.primaryContact;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["address4"] = this.address4;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        return data;
    }
}

export interface IPartnerSearch {
    partnerId?: string | undefined;
    name?: string | undefined;
    primaryContact?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    address4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProblemDetails | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProblemDetails>(data, _mappings, ProblemDetails);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ProductCountryResult implements IProductCountryResult {
    countryCode?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    manualHold?: boolean | undefined;
    holdStatus?: boolean | undefined;

    constructor(data?: IProductCountryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.exportTariffCode = _data["exportTariffCode"];
            this.importTariffCode = _data["importTariffCode"];
            this.eccn = _data["eccn"];
            this.manualHold = _data["manualHold"];
            this.holdStatus = _data["holdStatus"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductCountryResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductCountryResult>(data, _mappings, ProductCountryResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["exportTariffCode"] = this.exportTariffCode;
        data["importTariffCode"] = this.importTariffCode;
        data["eccn"] = this.eccn;
        data["manualHold"] = this.manualHold;
        data["holdStatus"] = this.holdStatus;
        return data;
    }
}

export interface IProductCountryResult {
    countryCode?: string | undefined;
    exportTariffCode?: string | undefined;
    importTariffCode?: string | undefined;
    eccn?: string | undefined;
    manualHold?: boolean | undefined;
    holdStatus?: boolean | undefined;
}

export class ProductOutRecord implements IProductOutRecord {
    productId?: string | undefined;
    orgCode?: string | undefined;
    companyCode?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: string | undefined;
    weightUnit?: string | undefined;
    grossWeight?: string | undefined;
    status?: string | undefined;
    productCountryRecord?: ProductRecordProductCountryRecord[] | undefined;
    integrationStatus?: ProductRecordIntegrationStatus[] | undefined;

    constructor(data?: IProductOutRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.orgCode = _data["orgCode"];
            this.companyCode = _data["companyCode"];
            this.productDescription = _data["productDescription"];
            this.productFamily = _data["productFamily"];
            this.manualHold = _data["manualHold"];
            this.weightUnit = _data["weightUnit"];
            this.grossWeight = _data["grossWeight"];
            this.status = _data["status"];
            if (Array.isArray(_data["productCountryRecord"])) {
                this.productCountryRecord = [] as any;
                for (let item of _data["productCountryRecord"])
                    this.productCountryRecord.push(ProductRecordProductCountryRecord.fromJS(item, _mappings));
            }
            if (Array.isArray(_data["integrationStatus"])) {
                this.integrationStatus = [] as any;
                for (let item of _data["integrationStatus"])
                    this.integrationStatus.push(ProductRecordIntegrationStatus.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductOutRecord | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductOutRecord>(data, _mappings, ProductOutRecord);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["orgCode"] = this.orgCode;
        data["companyCode"] = this.companyCode;
        data["productDescription"] = this.productDescription;
        data["productFamily"] = this.productFamily;
        data["manualHold"] = this.manualHold;
        data["weightUnit"] = this.weightUnit;
        data["grossWeight"] = this.grossWeight;
        data["status"] = this.status;
        if (Array.isArray(this.productCountryRecord)) {
            data["productCountryRecord"] = [];
            for (let item of this.productCountryRecord)
                data["productCountryRecord"].push(item.toJSON());
        }
        if (Array.isArray(this.integrationStatus)) {
            data["integrationStatus"] = [];
            for (let item of this.integrationStatus)
                data["integrationStatus"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductOutRecord {
    productId?: string | undefined;
    orgCode?: string | undefined;
    companyCode?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: string | undefined;
    weightUnit?: string | undefined;
    grossWeight?: string | undefined;
    status?: string | undefined;
    productCountryRecord?: ProductRecordProductCountryRecord[] | undefined;
    integrationStatus?: ProductRecordIntegrationStatus[] | undefined;
}

export class ProductRecordIntegrationStatus implements IProductRecordIntegrationStatus {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;

    constructor(data?: IProductRecordIntegrationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductRecordIntegrationStatus | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductRecordIntegrationStatus>(data, _mappings, ProductRecordIntegrationStatus);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        return data;
    }
}

export interface IProductRecordIntegrationStatus {
    statusCode?: string | undefined;
    statusDescription?: string | undefined;
}

export class ProductRecordProductCountryRecord implements IProductRecordProductCountryRecord {
    productId?: string | undefined;
    orgCode?: string | undefined;
    countryCode?: string | undefined;
    productDescription?: string | undefined;
    manualHold?: string | undefined;
    weightUnit?: string | undefined;
    grossWeight?: string | undefined;
    exportHS?: string | undefined;
    exportHSDescription?: string | undefined;
    exportUOM1?: string | undefined;
    ecn?: string | undefined;
    importHS?: string | undefined;
    importHSDescription?: string | undefined;
    originCountryCode?: string | undefined;
    status?: string | undefined;
    extension?: ProductRecordProductCountryRecordExtension[] | undefined;

    constructor(data?: IProductRecordProductCountryRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.orgCode = _data["orgCode"];
            this.countryCode = _data["countryCode"];
            this.productDescription = _data["productDescription"];
            this.manualHold = _data["manualHold"];
            this.weightUnit = _data["weightUnit"];
            this.grossWeight = _data["grossWeight"];
            this.exportHS = _data["exportHS"];
            this.exportHSDescription = _data["exportHSDescription"];
            this.exportUOM1 = _data["exportUOM1"];
            this.ecn = _data["ecn"];
            this.importHS = _data["importHS"];
            this.importHSDescription = _data["importHSDescription"];
            this.originCountryCode = _data["originCountryCode"];
            this.status = _data["status"];
            if (Array.isArray(_data["extension"])) {
                this.extension = [] as any;
                for (let item of _data["extension"])
                    this.extension.push(ProductRecordProductCountryRecordExtension.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductRecordProductCountryRecord | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductRecordProductCountryRecord>(data, _mappings, ProductRecordProductCountryRecord);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["orgCode"] = this.orgCode;
        data["countryCode"] = this.countryCode;
        data["productDescription"] = this.productDescription;
        data["manualHold"] = this.manualHold;
        data["weightUnit"] = this.weightUnit;
        data["grossWeight"] = this.grossWeight;
        data["exportHS"] = this.exportHS;
        data["exportHSDescription"] = this.exportHSDescription;
        data["exportUOM1"] = this.exportUOM1;
        data["ecn"] = this.ecn;
        data["importHS"] = this.importHS;
        data["importHSDescription"] = this.importHSDescription;
        data["originCountryCode"] = this.originCountryCode;
        data["status"] = this.status;
        if (Array.isArray(this.extension)) {
            data["extension"] = [];
            for (let item of this.extension)
                data["extension"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductRecordProductCountryRecord {
    productId?: string | undefined;
    orgCode?: string | undefined;
    countryCode?: string | undefined;
    productDescription?: string | undefined;
    manualHold?: string | undefined;
    weightUnit?: string | undefined;
    grossWeight?: string | undefined;
    exportHS?: string | undefined;
    exportHSDescription?: string | undefined;
    exportUOM1?: string | undefined;
    ecn?: string | undefined;
    importHS?: string | undefined;
    importHSDescription?: string | undefined;
    originCountryCode?: string | undefined;
    status?: string | undefined;
    extension?: ProductRecordProductCountryRecordExtension[] | undefined;
}

export class ProductRecordProductCountryRecordExtension implements IProductRecordProductCountryRecordExtension {
    extensionField?: ProductRecordProductCountryRecordExtensionExtensionField[] | undefined;
    extensionTemplate?: string | undefined;

    constructor(data?: IProductRecordProductCountryRecordExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["extensionField"])) {
                this.extensionField = [] as any;
                for (let item of _data["extensionField"])
                    this.extensionField.push(ProductRecordProductCountryRecordExtensionExtensionField.fromJS(item, _mappings));
            }
            this.extensionTemplate = _data["extensionTemplate"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductRecordProductCountryRecordExtension | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductRecordProductCountryRecordExtension>(data, _mappings, ProductRecordProductCountryRecordExtension);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extensionField)) {
            data["extensionField"] = [];
            for (let item of this.extensionField)
                data["extensionField"].push(item.toJSON());
        }
        data["extensionTemplate"] = this.extensionTemplate;
        return data;
    }
}

export interface IProductRecordProductCountryRecordExtension {
    extensionField?: ProductRecordProductCountryRecordExtensionExtensionField[] | undefined;
    extensionTemplate?: string | undefined;
}

export class ProductRecordProductCountryRecordExtensionExtensionField implements IProductRecordProductCountryRecordExtensionExtensionField {
    name?: string | undefined;

    constructor(data?: IProductRecordProductCountryRecordExtensionExtensionField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any, _mappings?: any): ProductRecordProductCountryRecordExtensionExtensionField | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductRecordProductCountryRecordExtensionExtensionField>(data, _mappings, ProductRecordProductCountryRecordExtensionExtensionField);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IProductRecordProductCountryRecordExtensionExtensionField {
    name?: string | undefined;
}

export class ProductResult implements IProductResult {
    productId?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: boolean | undefined;
    holdStatus?: boolean | undefined;
    productCountries?: ProductCountryResult[] | undefined;

    constructor(data?: IProductResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productDescription = _data["productDescription"];
            this.productFamily = _data["productFamily"];
            this.manualHold = _data["manualHold"];
            this.holdStatus = _data["holdStatus"];
            if (Array.isArray(_data["productCountries"])) {
                this.productCountries = [] as any;
                for (let item of _data["productCountries"])
                    this.productCountries.push(ProductCountryResult.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductResult | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductResult>(data, _mappings, ProductResult);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productDescription"] = this.productDescription;
        data["productFamily"] = this.productFamily;
        data["manualHold"] = this.manualHold;
        data["holdStatus"] = this.holdStatus;
        if (Array.isArray(this.productCountries)) {
            data["productCountries"] = [];
            for (let item of this.productCountries)
                data["productCountries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProductResult {
    productId?: string | undefined;
    productDescription?: string | undefined;
    productFamily?: string | undefined;
    manualHold?: boolean | undefined;
    holdStatus?: boolean | undefined;
    productCountries?: ProductCountryResult[] | undefined;
}

export class ProductSearch implements IProductSearch {
    repoName?: string | undefined;
    materialId?: string | undefined;
    synonyms?: string | undefined;
    countryCodes?: string[] | undefined;

    constructor(data?: IProductSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.repoName = _data["repoName"];
            this.materialId = _data["materialId"];
            this.synonyms = _data["synonyms"];
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes.push(item);
            }
        }
    }

    static fromJS(data: any, _mappings?: any): ProductSearch | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ProductSearch>(data, _mappings, ProductSearch);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repoName"] = this.repoName;
        data["materialId"] = this.materialId;
        data["synonyms"] = this.synonyms;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        return data;
    }
}

export interface IProductSearch {
    repoName?: string | undefined;
    materialId?: string | undefined;
    synonyms?: string | undefined;
    countryCodes?: string[] | undefined;
}

export class Project implements IProject {
    batchId?: number;
    projectId?: number;
    project?: string | undefined;
    id?: string | undefined;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any, _mappings?: any): Project | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Project>(data, _mappings, Project);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["projectId"] = this.projectId;
        data["project"] = this.project;
        data["id"] = this.id;
        return data;
    }
}

export interface IProject {
    batchId?: number;
    projectId?: number;
    project?: string | undefined;
    id?: string | undefined;
}

export class RaceResponseModel implements IRaceResponseModel {
    countryLabels?: CountryLabel[] | undefined;

    constructor(data?: IRaceResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            if (Array.isArray(_data["countryLabels"])) {
                this.countryLabels = [] as any;
                for (let item of _data["countryLabels"])
                    this.countryLabels.push(CountryLabel.fromJS(item, _mappings));
            }
        }
    }

    static fromJS(data: any, _mappings?: any): RaceResponseModel | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<RaceResponseModel>(data, _mappings, RaceResponseModel);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryLabels)) {
            data["countryLabels"] = [];
            for (let item of this.countryLabels)
                data["countryLabels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRaceResponseModel {
    countryLabels?: CountryLabel[] | undefined;
}

export class ReservationSearchInput implements IReservationSearchInput {
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    requestedUOM?: string | undefined;

    constructor(data?: IReservationSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.productSourceSystem = _data["productSourceSystem"];
            this.productIdentifier = _data["productIdentifier"];
            this.requestedUOM = _data["requestedUOM"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReservationSearchInput | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReservationSearchInput>(data, _mappings, ReservationSearchInput);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productSourceSystem"] = this.productSourceSystem;
        data["productIdentifier"] = this.productIdentifier;
        data["requestedUOM"] = this.requestedUOM;
        return data;
    }
}

export interface IReservationSearchInput {
    productSourceSystem?: string | undefined;
    productIdentifier?: string | undefined;
    requestedUOM?: string | undefined;
}

export class ReservationsSearchResults implements IReservationsSearchResults {
    lotNumber?: string | undefined;
    reservationAmountKG?: number | undefined;
    reservationAmountConverted?: number | undefined;
    isGLP?: boolean | undefined;
    reservationTypeName?: string | undefined;
    reservationTypeID?: number | undefined;
    warehouseID?: number | undefined;
    warehouseName?: string | undefined;

    constructor(data?: IReservationsSearchResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.lotNumber = _data["lotNumber"];
            this.reservationAmountKG = _data["reservationAmountKG"];
            this.reservationAmountConverted = _data["reservationAmountConverted"];
            this.isGLP = _data["isGLP"];
            this.reservationTypeName = _data["reservationTypeName"];
            this.reservationTypeID = _data["reservationTypeID"];
            this.warehouseID = _data["warehouseID"];
            this.warehouseName = _data["warehouseName"];
        }
    }

    static fromJS(data: any, _mappings?: any): ReservationsSearchResults | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<ReservationsSearchResults>(data, _mappings, ReservationsSearchResults);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lotNumber"] = this.lotNumber;
        data["reservationAmountKG"] = this.reservationAmountKG;
        data["reservationAmountConverted"] = this.reservationAmountConverted;
        data["isGLP"] = this.isGLP;
        data["reservationTypeName"] = this.reservationTypeName;
        data["reservationTypeID"] = this.reservationTypeID;
        data["warehouseID"] = this.warehouseID;
        data["warehouseName"] = this.warehouseName;
        return data;
    }
}

export interface IReservationsSearchResults {
    lotNumber?: string | undefined;
    reservationAmountKG?: number | undefined;
    reservationAmountConverted?: number | undefined;
    isGLP?: boolean | undefined;
    reservationTypeName?: string | undefined;
    reservationTypeID?: number | undefined;
    warehouseID?: number | undefined;
    warehouseName?: string | undefined;
}

export class Synonym implements ISynonym {
    compositionId?: number | undefined;
    synonymId?: number | undefined;
    name?: string | undefined;
    synonymTypeId?: string | undefined;

    constructor(data?: ISynonym) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.compositionId = _data["compositionId"];
            this.synonymId = _data["synonymId"];
            this.name = _data["name"];
            this.synonymTypeId = _data["synonymTypeId"];
        }
    }

    static fromJS(data: any, _mappings?: any): Synonym | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Synonym>(data, _mappings, Synonym);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compositionId"] = this.compositionId;
        data["synonymId"] = this.synonymId;
        data["name"] = this.name;
        data["synonymTypeId"] = this.synonymTypeId;
        return data;
    }
}

export interface ISynonym {
    compositionId?: number | undefined;
    synonymId?: number | undefined;
    name?: string | undefined;
    synonymTypeId?: string | undefined;
}

export class Us implements IUs {
    batchId?: number | undefined;
    batuseUseId?: number | undefined;
    useId?: number | undefined;
    use?: string | undefined;

    constructor(data?: IUs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any, _mappings?: any) {
        if (_data) {
            this.batchId = _data["batchId"];
            this.batuseUseId = _data["batuseUseId"];
            this.useId = _data["useId"];
            this.use = _data["use"];
        }
    }

    static fromJS(data: any, _mappings?: any): Us | null {
        data = typeof data === 'object' ? data : {};
        return createInstance<Us>(data, _mappings, Us);
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchId"] = this.batchId;
        data["batuseUseId"] = this.batuseUseId;
        data["useId"] = this.useId;
        data["use"] = this.use;
        return data;
    }
}

export interface IUs {
    batchId?: number | undefined;
    batuseUseId?: number | undefined;
    useId?: number | undefined;
    use?: string | undefined;
}

function jsonParse(json: any, reviver?: any) {
    json = JSON.parse(json, reviver);

    var byid: any = {};
    var refs: any = [];
    json = (function recurse(obj: any, prop?: any, parent?: any) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        
        if ("$ref" in obj) {
            let ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        } else if ("$id" in obj) {
            let id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        
        if (Array.isArray(obj)) {
            obj = obj.map((v, i) => recurse(v, i, obj));
        } else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }

        return obj;
    })(json);

    for (let i = 0; i < refs.length; i++) {
        const ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }

    return json;
}

function createInstance<T>(data: any, mappings: any, type: any): T | null {
  if (!mappings)
    mappings = [];
  if (!data)
    return null;

  const mappingIndexName = "__mappingIndex";
  if (data[mappingIndexName])
    return <T>mappings[data[mappingIndexName]].target;

  data[mappingIndexName] = mappings.length;

  let result: any = new type();
  mappings.push({ source: data, target: result });
  result.init(data, mappings);
  return result;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}